<template>
	<div class="indexbg">
		<topbar></topbar>
		<emallheader ref="c1"></emallheader>

		<headernav ref="navComp" :activeLi="activeLi"></headernav>
		<!--顶部：导航 结束-->

		<div class="clear mt15"></div>
		<div class="w1200 bc">
			<div class="hq-crumb-wrap">
				<ul>
					<li class="item">
					<a href="#">Home</a>
					</li>
					<li class="item sep">></li>
					<li class="item">
						<a v-on:click="getGoodListEn(catCode,goodsCatName)">{{goodsCatName}}</a>
					</li>
					<li class="item sep">></li>
					<li class="item">
						<a v-on:click="getGoodDetails(goodsCode)">{{goodsDetail.goodsNameEn}}</a>
					</li>
				</ul>
			</div>
			<!--位置 结束-->
			<div class="db-goods-show">
				<!--大图展示 开始-->
				<div class="goodspic">
					<div id="preview" class="spec-preview" >
						<span class="jqzoom"><img v-bind:jqimg="goodsImgLarge" v-bind:src="goodsImgLarge"  width="430px" height="430px"/></span>
						<div class="jqzoom-ico"><span><img src="../../../static/images/zoom.png" width="26" height="26"></span></div>
					</div>
					<!--缩图开始-->
					<div class="spec-scroll">
						<a class="prev" title="Previous"></a>
						<a class="next" title="Next"></a>
						<div class="items" >
							<ul >
								<li v-for="(gI,index) in goodsImgs">
									<img alt="" @click="choosePic(index)" v-bind:bimg="gI" v-bind:src="gI">
									<!--<img alt="" v-bind:bimg="gI" v-bind:src="gI" onmousemove="preview(this);">-->
								</li>
							</ul>
						</div>
					</div>
					<!--缩图结束-->
				</div>
				<!--大图展示 结束-->

				<div class="dt-m">
					<div class="sp-title">
						<!--<div class="sp-shop" v-if="isPreview == false">
							<a class="co1" @click="goShop(goodsBo.shopCode)"><div class="shop_name_overflow">{{ goodsBo.shopName }}</div></a>
						</div>-->
						<h3> {{ goodsNameEn }}</h3>
						<!--<p class="sp-tag"><span class="co1 mr5">闪电送货</span> <span class="co1 mr5">1年换新</span></p>-->
					</div>
					<!--v-if="isSpike == 'y'"-->
					<div class="shop-miaosha" v-if="seckillPrice!=''&&seckillPrice>0" >
            			<img class="miaosha-img" src="../../../static/images/miaosha_white.png" alt="" />
            				Spike
            				<!--<span class="miaosha-time"  v-if="goodsBo.saleStatus==='end'">
                				over
                			</span>
                			<span class="miaosha-time"  v-if="goodsBo.saleStatus==='wait_start'">
                				Distance start<i>{{hour}}</i>:<i>{{minute}}</i>:<i>{{second}}</i>
                			</span> -->
                			<span class="miaosha-time"  v-if="activityEndTime>0">
                				End of distance<i>{{hour}}</i>:<i>{{minute}}</i>:<i>{{second}}</i>
                			</span>
            		</div>
					<div class="shop-miaosha" v-if="seckillPrice=='' && nextBeginTime!=''" >
            			<img class="miaosha-img" src="../../../static/images/miaosha_white.png" alt="" />
            				Spike notice
            				<!--<span class="miaosha-time"  v-if="goodsBo.saleStatus==='end'">
                				over
                			</span>
                			<span class="miaosha-time"  v-if="goodsBo.saleStatus==='wait_start'">
                				Distance start<i>{{hour}}</i>:<i>{{minute}}</i>:<i>{{second}}</i>
                			</span> -->
                			<span class="miaosha-time"  v-if="nextBeginTime!= ''">
                				Expected{{nextBeginTime.substr(0,4)}}year{{nextBeginTime.substr(4,2)}}month{{nextBeginTime.substr(6,2)}}date{{nextBeginTime.substr(8,2)}}:{{nextBeginTime.substr(10,2)}}start
                			</span>
            		</div>
            		<h4 v-if="goodsBo.productType=='product'||goodsBo.productType=='meterial'" class="goods_b" v-bind:class='{"active":orderType === "spot","disableColor":goodsBo.goodsNumber<=10}' @click="(goodsBo.goodsNumber>10)?changeTab('spot'):''">Spot</h4>
            		<h4 v-if="goodsBo.productType=='product'||goodsBo.productType=='sample'" class="goods_b" v-bind:class='{"active":orderType === "custom"}' @click="changeTab('custom')">Custom</h4>
            		<h4 v-if="goodsBo.productType=='product'||goodsBo.productType=='sample'" class="goods_b" v-bind:class='{"active":orderType === "proof"}' @click="changeTab('proof')">Proof</h4>
            		<h4 v-if="goodsBo.productType=='meterial'" class="goods_b" v-bind:class='{"active":orderType === "purchase"}' @click="changeTab('purchase')">purchase</h4>
					<div v-if="orderType!='purchase'" class="sp-price">
						<!--<div class="item-1 fr tc">
							<p class="f16">{{ saleNumber+inpSaleNumber }}件</p>
							<p>已销售</p>
						</div>-->
						<div v-if="priceAreaJson!=''" style="float: left;width: 100%;">
							<div style="float: left;">
            					<dt v-if="orderType=='spot'" class="item-3" style="width: 70px;">price </dt>
            					<dt v-if="orderType!='spot'" class="item-3" style="width: 100px;">proposed price </dt>
            					<dt class="item-3" style="width: 70px;">number </dt>
            				</div>
	            			<li v-if="Array.isArray(JSON.parse(priceAreaJson).orderPrice)" v-for="(orderPrice,index) in JSON.parse(priceAreaJson).orderPrice" style="float: left;">
	            				<span v-if="index<(JSON.parse(priceAreaJson).orderPrice.length-1)" class="co2">￥<span class="f30 co2" :class="{fb: (payNum >= parseInt(JSON.parse(priceAreaJson).orderNum[index]) && payNum<parseInt(JSON.parse(priceAreaJson).orderNum[index+1]))}">{{orderPrice==0?'No price':orderPrice}}</span></span>
	            				<span v-if="index==(JSON.parse(priceAreaJson).orderPrice.length-1)" class="co2">￥<span class="f30 co2" :class="{fb: payNum >= parseInt(JSON.parse(priceAreaJson).orderNum[index])}">{{orderPrice==0?'No price':orderPrice}}</span></span>
	            				<br/>
	            				<div v-if="index<(JSON.parse(priceAreaJson).orderPrice.length-1)">{{JSON.parse(priceAreaJson).orderNum[index]}}-{{JSON.parse(priceAreaJson).orderNum[index+1]-1}}piece</div>
	            				<div v-if="index==(JSON.parse(priceAreaJson).orderPrice.length-1)">≥{{JSON.parse(priceAreaJson).orderNum[index]}}piece</div>
	            			</li>
	            			<li v-if="!Array.isArray(JSON.parse(priceAreaJson).orderPrice)" style="float: left;">
	            				<span class="co2">￥<span class="f30 co2 fb" >{{JSON.parse(priceAreaJson).orderPrice=='null' || JSON.parse(priceAreaJson).orderPrice==0?'No price':JSON.parse(priceAreaJson).orderPrice}}</span></span>
	            				<br/>
	            				<div>≥{{JSON.parse(priceAreaJson).orderNum}}piece</div>
	            			</li>
            			</div>
            			<div v-if="orderType!='spot'&&priceAreaJson!=''"  class="co3">Need to contact the background salesman to quote, in order to formally place an order.</div>
						<div class="item-2 co2" v-if="priceAreaJson==''&&goodsPrice1==0">
							<span style="color:#938a8c" v-if="isSpike == 'y'">秒杀价:</span>
							<span  v-if="(brokerDiscountPersent==0||brokerDiscountPersent==100)&&seckillPrice==0">
								<span class="co2"><span v-if="orderType!='spot'">proposed price：</span></span>￥<span class="f30 fb co2">{{goodsPrice==0?'No price':goodsPrice}}</span></span>
							</span>
							<span  v-if="(brokerDiscountPersent!=0&&brokerDiscountPersent!=100)||seckillPrice>0">
								<!--s>￥{{ goodsPrice }}</s-->
							</span>
							<span  v-if="brokerDiscountPersent!=0&&brokerDiscountPersent!=100&&seckillPrice==0">
								<span class="co2">￥<span class="f30 fb co2">{{ brokerPrice }}</span></span>
							</span>
							<span class="f30 fb" v-if="seckillPrice>0">price spike：￥{{ (seckillPrice/100).toFixed(2) }}</span>
							<span class="zhe" v-if="marketPrice>0">{{ discount }}discount</span>
							<span v-if="goodsBo.rewardPointRate>0&&(Math.floor(maxPrice*goodsBo.rewardPointRate/100)>0||chooseGoodsPrice>0)&&(chooseGoodsPrice!=''?Math.floor(chooseGoodsPrice*goodsBo.rewardPointRate/100):(Math.floor(minPrice*goodsBo.rewardPointRate/100)+'-'+Math.floor(maxPrice*goodsBo.rewardPointRate/100)))!=0" class="co_r mr10 f15"  style="font-size: 0.6rem !important;border: 1px red solid;border-radius: 3px;padding: 0 0.2rem 0 0.2rem;">
									gift{{chooseGoodsPrice!=''?Math.floor(chooseGoodsPrice*goodsBo.rewardPointRate/100/100):(Math.floor(minPrice*goodsBo.rewardPointRate/100)+"-"+Math.floor(maxPrice*goodsBo.rewardPointRate/100))}}point
								</span>
						</div>
						<div class="item-2 co2" v-if="priceAreaJson==''&&goodsPrice1!=0">
							<span class="f14"></span>
							<span class="f30 fb">{{ goodsPrice1 }}
									<span v-if="pointType == 'point'">point</span>
									<span v-else-if="pointType == 'special'">special point</span>
									<span v-else-if="pointType == 'red'">red point</span>
									<span v-else-if="pointType == 'blue'">blue point</span>
							</span>
						</div>
						<div v-if="orderType!='spot'&&priceAreaJson==''"  class="co3">The background salesman needs to contact the quotation before the official order can be placed.</div>
						<div class="item-3" v-if="marketPrice>0">Market price：<span class="cost-price">￥{{ marketPrice.toFixed(2) }}</span>（Save ￥{{ breaks }} for you ）</div>
						
					</div>
					<dl class="sp-meta" :class='{"top40":orderType === "purchase","top140":orderType != "purchase"}'>
						<div v-for="(skuAttr,index_n) in skuList">
							<dt v-if="skuAttr.skuNameEn != null&&skuAttr.skuNameEn != ''">{{skuAttr.skuNameEn}}：</dt>
							<!-- {{skuAttr.skuValueEn}} -->
							<dd v-if="skuAttr.skuValueEn != null&&skuAttr.skuValueEn != ''"><a v-for="(specItem,index) in skuAttr.skuValueEn.split(',')" v-if="specItem != null&&specItem != ''&&existsSku(specItem,index_n)"  @click="specItem != skuList[index_n].skuChoosed&&chooseSpec(specItem,index_n)" :class="{selected: specItem == skuList[index_n].skuChoosed}" class="td-txt">{{ specItem }}</a></dd>
						</div>
						<div v-if="orderType=='purchase'">
							<div v-if="goodsDetail.orderQuantity!=undefined&&goodsDetail.orderQuantity>0">
								<dt>Start quantity：</dt>
								<dd>{{goodsDetail.orderQuantity}}件</dd>
							</div>
							<div>
								<dt>Original price：</dt>
								<dd v-if="chooseGoodsPrice!=''" style="color: #EF920D;">￥{{goodsPrice}}</dd>
								<dd v-if="minPrice>0&&chooseGoodsPrice==''" style="color: #EF920D;">￥{{minPrice}}<span v-if="maxPrice>minPrice">  - ￥{{maxPrice}}</span></dd>
							</div>
							<div>
								<dt>Production quantity：</dt>
								<dd><input id="produceNum" type="number" onkeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" v-on:keyup="setProduceNum()" class="inpt" style="width:100px;" v-model="produceNum"  min="1"/>&nbsp;&nbsp;piece</dd>
							</div>
							
							<div>
								<dt>Inspection method</dt>
								<dd>
									<a v-for="(ins,index) in inspectionTypes" v-if="ins.dictValue!=''" @click="chooseInspection(ins.dictValue)" :class="{selected: inspectionType == ins.dictValue}" class="td-txt">{{ ins.dictText }}</a>
								</dd>
							</div>
						</div>
						<dt v-if="isLogin && (expressMode=='weight'||expressMode=='counter')">deliver to：</dt>
						<dd v-if="isLogin && (expressMode=='weight'||expressMode=='counter')">
							<span>deliver to：</span>
							<select v-on:input="expressChage()" id="expressChage"  class="city_select_css" >
								<option value="Beijing">Beijing</option>
								<option value="Tianjin" >Tianjin</option>
								<option value="Hebei Province">Hebei</option>
								<option value="Shanxi Province">Shanxi</option>
								<option value="Inner Mongolia Autonomous Region">Inner Mongolia</option>
								<option value="Liaoning Province">Liaoning</option>
								<option value="Jilin Province">Jilin</option>
								<option value="Heilongjiang Province">Heilongjiang</option>
								<option value="Shanghai">Shanghai</option>
								<option value="Jiangsu Province">Jiangsu </option>
								<option value="Zhejiang">Zhejiang</option>
								<option value="Anhui Province">Anhui</option>
								<option value="Fujian Province">Fujian</option>
								<option value="Jiangxi Province">Jiangxi</option>
								<option value="Shandong Province">Shandong</option>
								<option value="Henan Province">Henan</option>
								<option value="Hubei Province">Hubei</option>
								<option value="Hunan Province">Hunan</option>
								<option value="Guangdong Province">Guangdong</option>
								<option value="Guangxi Zhuang Autonomous Region">Guangxi</option>
								<option value="Hainan Province">Hainan</option>
								<option value="Chongqing Province">Chongqing</option>
								<option value="Sichuan Province">Sichuan</option>
								<option value="Guizhou Province">Guizhou</option>
								<option value="Yunnan Province">Yunnan</option>
								<option value="Tibet Autonomous Region">Tibet</option>
								<option value="Shaanxi Province">Shaanxi</option>
								<option value="Gansu Province">Gansu</option>
								<option value="Qinghai Province">Qinghai</option>
								<option value="Ningxia Hui Autonomous Region">Ningxia</option>
								<option value="Xinjiang Uygur Autonomous Region">Xinjiang</option>
								<option value="Hong Kong Special Administrative Region">Hong Kong</option>
								<option value="Macau Special Administrative Region">Macau</option>
								<option value="Taiwan Province">Taiwan</option>
							</select>
						</dd>
						
						
						
                		
                 <table>
                 	<!--<tr>
                 		<td><dt v-if="isLogin">Freight：</dt></td>
                 		<td v-if="isLogin">
                 			
							<span>&nbsp;{{expressFeeDesc}}</span>
							<span v-if="expressArea!=''">:&nbsp;{{expressArea}}</span>
						
                 		</td>
                 	</tr>-->
                 	
                 	
                 	<tr v-if="orderType=='custom'&&vailUserFlag==true && userIsLogin==true">
                 		<td><dt>Order description</dt></td><td><textarea v-model="customize_desc"  rows="5" cols="70"></textarea></td>
                 	</tr>
                 	<tr v-if="orderType=='proof'&&vailUserFlag==true && userIsLogin==true">
                 		<td><dt>Proofing requirements</dt></td><td>
                 			
                 			<table width="80%">
                 				<tr><td>Accessory name</td><td>Adjustment instructions</td></tr>
                 				<tr v-for="(partChange,k) in partChangeList"><td >
                 					<select v-model="partChange.name">
                 						<option v-for="(ptType,index) in partTypes"  v-if="isPartShow(k,index)">{{ptType.dictValue}}</option>
                 					</select></td>
                 					<td><input type="text" class="inpt" v-model="partChange.value"/>
                 					<a v-if="k==0" class="plus" style="" v-on:click="addPart()">+</a>
                 					<a v-if="k!=0" class="minus" style="" v-on:click="delPart(k)">-</a>
                 					</td>
                 				</tr>
                 					
                 			</table>
                 				
                 			
                 		</td>
                 	</tr>
                 	<tr v-if="(orderType=='proof'||orderType=='purchase')&&vailUserFlag==true && userIsLogin==true">
                 		<td><dt v-if="orderType=='proof'">Proofing notes</dt><dt v-if="orderType=='purchase'">Processing instructions</dt></td><td><textarea v-model="remark" rows="5" cols="70"></textarea></td>
                 	</tr>
                 	<tr v-if="(orderType=='proof'||orderType=='purchase')&&vailUserFlag==true && userIsLogin==true">
                 		<td><dt>Upload image</dt></td>
                 		<td>
                 			<button type="button" class="td-txt" style="width:80px"  @click="change_input()">Select</button>
                 		<form id="addTextForm" @change="setImg($event)">
                 			<input id="0" type="file" style="display:none;" name="style_picture"/>
                 			<input id="1" type="file" style="display:none;" name="style_picture"/>
                 			<input id="2" type="file" style="display:none;" name="style_picture"/>
                 			<input id="3" type="file" style="display:none;" name="style_picture"/>
                 			<input id="4" type="file" style="display:none;" name="style_picture"/>
                 		</form>
                 			<div id="img-wrapper" @click="deleteImg($event)">
                 				<img src="" id="img_0" style="max-width: 48%;display: none;max-height: 200px;">
                 				<img src="" id="img_1" style="max-width: 48%;display: none;max-height: 200px;">
                 				<img src="" id="img_2" style="max-width: 48%;display: none;max-height: 200px;">
                 				<img src="" id="img_3" style="max-width: 48%;display: none;max-height: 200px;">
                 				<img src="" id="img_4" style="max-width: 48%;display: none;max-height: 200px;">
                 			</div>
                 		</td>
                 	</tr>
			<tr>
                 		<td><dt  v-if="(orderType=='spot')&&goodsDetail.printService>0">Print service:</dt></td>
                 		<td v-if="(orderType=='spot')&&goodsDetail.printService>0"><a @click="choosePrint(goodsDetail.printService)" :class="{selected: printService != ''}" class="td-txt">Print</a>{{goodsDetail.printService/100}}￥ / piece 			
                 		</td>
                 	</tr>
                 	<tr v-if="orderType=='purchase'||orderType=='custom'">
						<td><dt v-if="goodsDetail.laserService>0">Laser service:</dt></td>
						<td v-if="goodsDetail.laserService>0">
							<a @click="chooseLaster(goodsDetail.laserService)" :class="{selected: laserService != ''}" class="td-txt">Laser</a>{{goodsDetail.laserService/100}}￥ / piece
						</td>
					</tr>
					<tr v-if="orderType=='purchase'||orderType=='custom'">
						<td><dt v-if="goodsDetail.printingService>0">Printing service:</dt></td>
						<td v-if="goodsDetail.printingService>0">
							<a @click="choosePrinting(goodsDetail.printingService)" :class="{selected: printingService != ''}" class="td-txt">Printing</a>{{goodsDetail.printingService/100}}￥ / piece
						</td>
					</tr>
					<tr v-if="orderType=='purchase'||orderType=='custom'">
						<td><dt v-if="goodsDetail.rebrandingService>0">Rebranding Service:</dt></td>
						<td v-if="goodsDetail.rebrandingService>0">
							<a @click="chooseRebranding(goodsDetail.rebrandingService)" :class="{selected: rebrandingService != ''}" class="td-txt">Rebranding</a>{{goodsDetail.rebrandingService/100}}￥ / piece
						</td>
					</tr>
					<tr v-if="(orderType=='spot'||orderType=='custom')&&goodsDetail.qualityService!=undefined&&goodsDetail.qualityService!=''">
						<td><dt>Quality level:</dt></td>
						<td>
							<span v-for="(qua,index) in qualitys" v-if="qua.dictValue==goodsDetail.qualityService">{{qua.remark}}</span>
						</td>
					</tr>
					<!--
					<tr v-if="orderType=='custom'&&(goodsDetail.qualityService==undefined||goodsDetail.qualityService=='')">
						<td><dt>Quality level:</dt></td>
						<td>
							<span v-for="(qua,index) in qualitys" v-if="qua.dictValue=='C'">{{qua.dictText}}</span>
						</td>
					</tr>
					-->
                    <tr v-if="((orderType=='spot'&&goodsDetail.printService>0)||orderType=='custom'||orderType=='proof')&&vailUserFlag==true && userIsLogin==true">
                 		<td><dt>Attachment</dt></td>
                 		<td>
                 			<button type="button" class="td-txt"  style="width:80px" @click="change_File()">Select</button>
                 			<form id="addFileForm" @change="setFile($event)">
                 				<input id="10" type="file" style="display:none;" name="attachment" @change="setFileName($event)"/><a id="a_10" class="minus" style="font-size: 20px;display:none;" v-on:click="deleteFile($event)">-</a>
                 				<input id="11" type="file" style="display:none;" name="attachment" @change="setFileName($event)"/><a id="a_11" class="minus" style="font-size: 20px;display:none;" v-on:click="deleteFile($event)">-</a>
                 				<input id="12" type="file" style="display:none;" name="attachment" @change="setFileName($event)"/><a id="a_12" class="minus" style="font-size: 20px;display:none;" v-on:click="deleteFile($event)">-</a>
                 				<input id="13" type="file" style="display:none;" name="attachment" @change="setFileName($event)"/><a id="a_13" class="minus" style="font-size: 20px;display:none;" v-on:click="deleteFile($event)">-</a>
                 				<input id="14" type="file" style="display:none;" name="attachment" @change="setFileName($event)"/><a id="a_14" class="minus" style="font-size: 20px;display:none;" v-on:click="deleteFile($event)">-</a>
                 			</form>
                 			
                 		</td>
                 	</tr>
                     
                 	
                 </table>
                 		<div v-if="(orderType=='purchase'||orderType=='proof')&&vailUserFlag==true && userIsLogin==true">
								<dt>Quality level</dt>
								<dd>
									<a v-for="(qua,index) in qualitys" v-if="qua.dictValue!=''" @click="chooseQuality(qua.dictValue)" :class="{selected: quality == qua.dictValue}" class="td-txt">{{ qua.remark }}</a>
									<a href="http://en.baomate.com/Baike/492.htm" target="_blank" style="color:blue">Quality standards and process requirements</a>
								</dd>
						</div>
						<dt v-if="(orderType=='spot'||orderType=='custom'||orderType=='proof')&&vailUserFlag==true && userIsLogin==true">Quantity：</dt>
						<dd v-if="(orderType=='spot'||orderType=='custom'||orderType=='proof')&&vailUserFlag==true && userIsLogin==true">
							<div class="hq-amount">
								<span class="fl">
				                	<a class="hq-amount-increase" href="javascript:void(0);" v-on:click="subPayNum()">-</a>
				                    <input id="payNum"  onkeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" v-on:keyup="setPayNum()" class="hq-amount-input" type="number" v-model="payNum"  min="1" v-bind:max="goodsNumber">
				                    <a class="hq-amount-decrease" href="javascript:void(0);" v-on:click = "addPayNum()">+</a>
                   				</span>
								<span v-if="orderType === 'spot'" class="fl ml10">Inventory {{ goodsNumber }} piece </span>
							</div>
						</dd>
						<dt v-if="goodsDetail.weight">Weight：</dt>
						<dd v-if="goodsDetail.weight">
							<div class="hq-amount">
								<span class="fl ">{{goodsDetail.weight}}</span>
							</div>
						</dd>
						<table>
						<tr v-if="(orderType=='custom'||orderType=='proof')&&vailUserFlag==true && userIsLogin==true">
                 			<td><dt>Expected delivery</dt></td>
                 			<td>
                 				<!--<input v-model="begin_delivery_time" type="date" class="inpt" :min="currDate"/>-->
                 			<datepicker type="date" name="begin_delivery_time" :readonly="true" v-model="begin_delivery_time" :disabled-date="disabledDate"></datepicker>
                 			</td>
                 		
						</tr>
                 	</table>
					</dl>
					
					<div class="sp-action" v-if="goodsBo.isDelete=='Y'">
						<a v-if="orderType=='proof'" class="delisting-bccolor">Goods has expired</a>
						<a v-if="orderType=='custom'" class="delisting-bccolor">Goods has expired</a>
						<a v-if="orderType=='spot'" class="delisting-bccolor">Goods has expired</a>
						<a v-if="orderType=='purchase'" class="delisting-bccolor">Goods has expired</a>
					</div>
					<div class="sp-action" v-if="goodsBo.isDelete!='Y'">
						<span v-if="orderType=='proof'">
							<a v-if="vailUserFlag==true && userIsLogin==true" class="sp-link-buy" v-on:click="customizeApply('proof')">Proof application</a>
							<a v-if="vailUserFlag==false && userIsLogin==true" class="sp-link-buy" v-on:click="toEditUserInfo()">Perfect information</a>
						</span>
						<span v-if="orderType=='custom'">
							<a v-if="vailUserFlag==true  && userIsLogin==true" class="sp-link-buy" v-on:click="customizeApply('subscribe')">Order application</a>
							<a v-if="vailUserFlag==false && userIsLogin==true" class="sp-link-buy" v-on:click="toEditUserInfo()">Perfect information</a>
						</span>
						<a v-if="vailUserFlag==true && orderType=='spot'" v-bind:class="{ dactive: goodsNumber === 0,'delisting-bccolor':goodsBo.shopGoodsStatus==='delisting','sp-link-buy':goodsBo.shopGoodsStatus==='listing'}" v-on:click="!isPreview&&(goodsNumber > 0)&&goodsBo.shopGoodsStatus=='listing'&&payOrder()">{{goodsBo.shopGoodsStatus=='delisting'?'Has been removed':'Place an order now'}}</a>
						<a v-if="userIsLogin==true  && orderType=='purchase'" v-bind:class="{ 'delisting-bccolor':goodsBo.shopGoodsStatus==='delisting','sp-link-buy':goodsBo.shopGoodsStatus==='listing'}" v-on:click="goodsBo.shopGoodsStatus=='listing'&&payOrder()">{{goodsBo.shopGoodsStatus=='delisting'?'Has been removed':'Purchase order'}}</a>
						<a v-bind:class="{ dactive: goodsNumber === 0 }" class="sp-link-add" v-if="userIsLogin==true && orderType=='spot'&&canAddToShoppingCart&&distributeAccount ==''&&goodsBo.shopGoodsStatus==='listing'&&seckillPrice==0" v-on:click="!isPreview&&(goodsNumber > 0)&&addToShoppingCart()"><i class="ico-cart-w"></i>add to Shopping Cart</a>
						<a v-if="userIsLogin==false" class="sp-link-add" v-on:click="toUserLogin()">Please sign in</a>
						<a class="sp-link-add" v-on:click="toContactSupplier(goodsBo.goodsCode)">Contact supplier</a>
					</div>
					<div class="sp-other">
						<span class="mr40" v-if="goodsBo.isDelete!='Y'"><i class="ico-sp-sc"></i><a class="co1" v-on:click="!isPreview&&addOrDeleteFavoriteGoods()">{{ isExistFavoriteGoods==0? 'Collection' : 'Collected' }}</a></span>
						<span class="co1" v-if="goodsBo.seven_day_return=='Y'"><i class="ico-sp-tk"></i>Support 7 days no reason to return service</span>
					</div>
					<!--分享-->
					<div>
						<div class="post_btmshare">
							<span class="post_topshare_title">share to：</span>
							<ul class="post_share">
								<li class="share_weixin js_weixin" data-type="btm" v-on:click="easyShare('weixin')">
									<a target="_self"><i title="Share to WeChat"></i><span></span> WeChat</a>
								</li>
								<li class="share_qzone js_share" data-type="qzone" v-on:click="easyShare('qzone')">
									<a target="_self"><i title="Share to QQ space"></i><span></span>QQ space</a>
								</li>
								<li class="share_weibo js_share" data-type="weibo" v-on:click="easyShare('weibo')">
									<a target="_self"><i title="Share to Sina Weibo"></i><span></span>Weibo</a>
								</li>
							</ul>
							<div class="js_qrcode_wrap" id="js_qrcode_top">
								<div class="js_qrcode_arr"></div>
                                <a target="_self" v-on:click="closeqrcode" class="js_qrcode_close" data-type="top" title="Close"></a>
                                <div class="js_qrcode_img js_share_qrcode" title=""><canvas id="canvas" width="120" height="120"></canvas><img src="" /></div>
                                <p>Scan QR code with WeChat</p>
                                <p>Share to friends and circles</p>
                            </div>
						</div>
					</div>
				</div>
				<div class="clear"></div>
			</div>

			 <!-- 右侧商品 开始-->
    <div class="sp-side-wrap mt20">
    	<div class="hd">
            <a class="refresh fr" @click="!isPreview&&refreshGoods()"></a>
            <h3>you may also like</h3>
        </div>
        <ul>
            <li v-for="goodBo in recommendGoodsList">
                <a class="fl pic" @click="goDetail(goodBo.goodsCode)"><img :src="goodBo.imgMiddle" width="106" height="106" ></a>
                <p class="title">
                    <a @click="goDetail(goodBo.goodsCode)">{{goodBo.goodsNameEn}}</a>
                </p>
                <p class="price co2">￥{{(goodBo.unitPrice/100).toFixed(2)}}</p>
            </li>

        </ul>
    </div>
    <!-- 右侧商品 结束-->

		 <!-- 商品详情 开始-->
    <div class="sp-dt-tab">
    	<div class="hd">
        	<ul>
            	<li class="hover"><a href="javascript:void(0);">Product Description</a></li>
                <li><a href="javascript:void(0);">Product Reviews</a></li>
            </ul>
        </div>
        <div class="bd">
        	<!--<div class="sp-dp-box">
           	  	<div class="fr b-r tc" v-on:click="!isPreview&&addOrDeleteFavoriteShop()">
                	<i class="ico-dp-sc " v-bind:class="{'active':isExistFavoriteShop==1}"></i>
                	<p class="co5">{{ isExistFavoriteShop==0? 'Collection' : 'Collected' }}</p>
                </div>
                <img v-if="shopLogo!=''" class="fl" v-bind:src="shopLogo" width="135" height="60">
                <div class="b-m">
                	<p>
                        <span class="f14 co1 vm"><a @click="goShop(goodsBo.shopCode)">{{goodsBo.shopName}}</a></span>
                        <span v-if="shopInfo.creditPoint>=4&&shopInfo.creditPoint<=10" class="vip_rank_1 vm"></span>
								<span v-if="shopInfo.creditPoint>=11&&shopInfo.creditPoint<=40" class="vip_rank_2 vm"></span>
								<span v-if="shopInfo.creditPoint>=41&&shopInfo.creditPoint<=90" class="vip_rank_3 vm"></span>
								<span v-if="shopInfo.creditPoint>=91&&shopInfo.creditPoint<=150" class="vip_rank_4 vm"></span>
								<span v-if="shopInfo.creditPoint>=151&&shopInfo.creditPoint<=250" class="vip_rank_5 vm"></span>
								<span v-if="shopInfo.creditPoint>=251&&shopInfo.creditPoint<=500" class="vip_rank_6 vm"></span>
								<span v-if="shopInfo.creditPoint>=501&&shopInfo.creditPoint<=1000" class="vip_rank_7 vm"></span>
								<span v-if="shopInfo.creditPoint>=1001&&shopInfo.creditPoint<=2000" class="vip_rank_8 vm"></span>
								<span v-if="shopInfo.creditPoint>=2001&&shopInfo.creditPoint<=5000" class="vip_rank_9 vm"></span>
								<span v-if="shopInfo.creditPoint>=5001&&shopInfo.creditPoint<=10000" class="vip_rank_10 vm"></span>
								<span v-if="shopInfo.creditPoint>=10001&&shopInfo.creditPoint<=20000" class="vip_rank_11 vm"></span>
								<span v-if="shopInfo.creditPoint>=20001&&shopInfo.creditPoint<=50000" class="vip_rank_12 vm"></span>
								<span v-if="shopInfo.creditPoint>=50001&&shopInfo.creditPoint<=100000" class="vip_rank_13 vm"></span>
								<span v-if="shopInfo.creditPoint>=100001&&shopInfo.creditPoint<=200000" class="vip_rank_14 vm"></span>
								<span v-if="shopInfo.creditPoint>=200001" class="vip_rank_15"></span>
               	  </p>
                    <p class="mt15" >
                    	<span class="co5 vm">在线客服：</span>
                        <a class="a-online-zx" href="#">在线咨询</a>
                       <a style="display: inline-block;" class="vm" target="_blank" v-bind:href="qqUrl"><img border="0" src="http://pub.idqqimg.com/qconn/wpa/button/button_111.gif" alt="在线客服" title="在线客服"/></a>
                    </p>
                </div>
            </div>-->
        	<ul class="details-sp-cs">
             <li style="width:100%">Product name：{{ goodsNameEn }}</li>
             <li v-if="goodsDetail.brandName!=null&&goodsDetail.brandName!=''">Brand： {{ goodsDetail.brandName }}</li>
             <li>Product Code：{{ goodsCode }}</li>
             <!--<li>净含量：{{ goodsDetail.netContent}}  </li>
             <li>规格：{{ goodsDesc }}  </li>-->
             <!--<li>生产企业：三绿有机食品有限公司 </li>
             <li>产品编号: 131009012694</li>
             <li>产品型号：秋葵</li>
             <li>执行标准：食品质量安全准入标准 </li>
             <li>产地：中国大陆</li>
             <li>包装： 散装 </li>
             <li>生产日期：2015-01-05</li>
             <li>纯度%：100% </li>
             <li>净度%：98%</li>
             <li>芽率%：98% </li>
             <li>水份%：98% </li>
             <li>成活率%：100%  </li>
             <li>等级：A级 </li>
             <li>生产企业产品编号：345583545</li>
             <li><a href="#">附件</a> </li>-->
            </ul>
<!--            <dl class="details-sp-zy">
            	<dt>说明：</dt>
                <dd>
                	<div  v-html ="goodsDesc">
                		{{ goodsDesc }}
              	  </div>
                </dd>
            </dl>-->
        	<h4 class="title"><i class="ico-l"></i>Product Details</h4>
            <div class="content">
          	<!--<img v-bind:src="goodsImgLarge" width="859" height="1281">-->
          		<div style="height: 20rem;" v-if="goodsDetail.goodsVideo">
					<video controls="controls" style="height: 20rem;margin-left: 5.5rem;" width="80%">
					  <source :src="imgPath + goodsDetail.goodsVideo" />
					  Your browser does not support the video tag.
					</video>
				</div>

          		<div class="img-list"  v-html ="goodsDescEn">
                		{{ goodsDescEn }}
              	</div>
            </div>
        </div>
        <div class="bd none">
       	  <h4 class="title"><i class="ico-l"></i>Product Reviews
        	<div class="haopin" v-if="goodRate!=null">Reward rate <span><strong>{{ goodRate }}</strong>%</span></div>
       	  </h4>
            <div class="content">
            	<div class="details-sp-pinjia" v-for="(credit,creditIdx) in creditList">
                 <div class="details-sp-pinjia-col-1">
                     <p class="pinjia-ms">
                     	 Describe the degree of conformity: <span :class="'sp-pj-star star'+credit.creditPoint"></span> 
                     	 Shipping speed:<span :class="'sp-pj-star star'+credit.speedPoint"></span>
                     	 Service attitude: <span :class="'sp-pj-star star'+credit.attitudePoint"></span>
                     </p>
                     <p class="pinjia-con">{{credit.content}}</p>
                     <div v-if="credit.creditImgs!=undefined && credit.creditImgs.length>0" class="pinjia-img">
                     		<img v-for="(gI,imgIdx) in credit.creditImgs" @click="showImg(creditIdx,gI)" alt="" v-bind:bimg="gI" v-bind:src="gI" width="48" height="48">
                     </div>
                     <div :id="creditIdx+'_div'" style="display: none;" class="pinjia_scale_img">
                     		<img :id="creditIdx"  @click="hideImg(creditIdx)">
                     </div>
                 </div>
                 <div v-if="credit.ext2!=undefined && credit.ext2!=''" class="details-sp-pinjia-col-1">
                     <p class="pinjia-con"><span style="color: #999">[Additional comments]</span><br>{{credit.ext2}}</p>
                     <div v-if="credit.appendImgs!=undefined && credit.appendImgs.length>0" class="pinjia-img">
                     		<img v-for="(gI_append,imgIdx) in credit.appendImgs" @click="showAppendImg(creditIdx,gI_append)" alt="" v-bind:bimg="gI_append" v-bind:src="gI_append" width="48" height="48">
                     </div>
                     <div :id="creditIdx+'_append_div'" style="display: none;" class="pinjia_scale_img">
                     		<img :id="creditIdx+'_append'"  @click="hideAppendImg(creditIdx)">
                     </div>
                 </div>
                 <div class="details-sp-pinjia-col-2">
                     <p class="pj-user"><span>Evaluator：</span> {{credit.buyerName}}（anonymous）</p>
                     <p class="pj-time">{{credit.dataStr}} </p>
                 </div>
           </div>

            </div>
        </div>
    </div>
    <!-- 商品详情 结束-->
	<div class="top" v-on:click="scrollToTop()">
		<a><span>TOP</span></a>
	</div>


		</div>
		<div class="clear"></div>
		<footermenu></footermenu>
		<footercopyright></footercopyright>
	</div>

</template>
<script>
	import TopBar from '@/components/TopBar'
	import FooterMenu from '@/components/FooterMenu'
	import ShopNav from '@/components/ShopNav'
	import FooterCopyright from '@/components/FooterCopyright'
	import HearderNav from '@/components/HearderNav'
	import Header from '@/components/Header'
	//import jQuery from "../../../static/js/jqzoom.base.js"
	import jQuery from 'jquery';
	import API from "../../../static/api/api.js"
	import alertConfirm from "../../../static/js/alertConfirm.js"
	import {mobileGoodsDetailUrl,getAjaxUrl,getImgUrl,dateFormat,getValueFromMap,showMoney,parseResult,getUcUrl,getEmallUrl,compareDate} from "../../../static/js/emallUtils.js"
	import Vue from 'vue'
	import VueResource from 'vue-resource'
	import VueRouter from 'vue-router'
	//引入滚动和放大插件
	import "../../../static/js/jquery.jqzoom.js";
	import "../../../static/js/jqzoom.base.js";
	import datepicker from 'vue-date-picker';
	Vue.use(VueRouter)
	Vue.use(VueResource)

	import QRCode from 'qrcode';
    Vue.use(QRCode);
/** 
	 * 从 file 域获取 本地图片 url 
	 */
	function getFileUrl(obj) {
		let url;
		url = window.URL.createObjectURL(obj.files.item(0));
		return url;
	}
	export default {
		name: 'goodsdetail',
		components: {
			'topbar': TopBar,
			'shopnav': ShopNav,
			'footermenu': FooterMenu,
			'footercopyright': FooterCopyright,
			'emallheader': Header,
			'headernav': HearderNav,
			'datepicker': datepicker
		},
		data(){
            return {
            	goodsDetail:{},
            	goodsDesc:'',
            	goodsDescEn:'',
            	goodsName:'',
            	goodsNameEn:'',
            	goodsPrice:'',
		goodsPrice1: '', //不知道谁占了名字
            	goodsCode: '',
            	goodsCatNameCn:'',
            	goodsCatName:'',
            	goodsNumber:0,
            	shoppingCartNum:'',
            	payNum:1,
            	currentNum:'',
            	buyGoodsNumber:'',
            	isLimitGoodsFlag:'',
            	goodsQuota:'',
            	priceText:'',
            	greenshoeUser:'',
            	backUrl:'',
            	goodsImgs:[],
            	goodsImgLarge:'',
            	goodsImgMid:'',
            	goodsImgSml:'',
            	slider: [{imgUrl:""}],
            	sliderHeight: '17.8rem',
            	goodsLimitMax:'',
            	shopCode:'',
            	saleNumber:0,
            	inpSaleNumber:0,
            	shopInfo: {},
//          	shopLogo:'../../static/images/temp/sp-dp-logo.jpg',
				shopLogo:'',
            	qqUrl:'',
            	breaks:0,
            	creditList:[],
            	discount:0,
            	marketPrice:0,
            	catCode:'',
            	recommendGoodsList:[],
            	distributeName:'',
            	distributeAccount:'',
            	catList:[],
            	isExistFavoriteGoods:0,
            	isExistFavoriteShop:0,
            	goodsBo:{},
            	currentPage:1,
            	totalPage:1,
            	isPreview:false,
            	brokerDiscountPersent:0,
            	brokerPrice:0,
            	spec:'',
            	specName:'',
            	specNameEn:'',
            	goodRate:null,
            	isSpike:'n',
	   			computeFlag:'',
	   			hour:0,
	   			minute:0,
	   			second:0,
				isLogin: false,
				shopName:'',
				shopNameEn:'',
				expressBo:{},
				expressFeeBoList:[],
				expressFeeDesc:'',//运费
				expressMode:'',//运费类别
				expressArea:'',//运费地区
				skuList:[],//类目关联的SKU
				goodsSkuList:[],//商品关联的SKU
				usedSkuArry:[],//商品使用的SKU，二维数组
				goodsSkuMap:new Map(),  //商品关联的SKU的MAP
				hour:'0',
	   			minute:'0',
	   			second:'0',
	   			activityEndTime:'',
	   			seckillPrice:'',
                pointType:'',//积分类型
                unselectSKU:false,//是否规格已经全部选择
                chooseGoodsPrice:0,
				maxPrice:0,
				minPrice:0,
				nextSecckill: {},
				nextBeginTime:'',
				canAddToShoppingCart:true,
				attachName:'',//附件名称
				attachPath:'',//附件路径
				orderType:'spot',//当前订单类型
				printService: '', //印刷服务
				rebrandingService: '', //换标服务
				printingService: '', //印花服务
				laserService: '', //激光服务
				customize_desc:'',//定制要求
				customize_desc:'',//定制要求
				remark:'',//备注
				begin_delivery_time:'',//交期
				partTypes:'',//产品部件
				partChangeList:[],
				imgNum: 5, //上传的照片数量，可根据实际情况自定义
				priceAreaJson:'',//多级报价
				produceNum: '', //生产数量
				qualitys: [], //品质集合
				inspectionTypes: [], //验收集合
				quality: 'C', //选中的品质
				inspectionType: '',
				currDate:'',
				activeLi:"mallIndex",
				maxBuyNum:9,//现货产品的最大购买数量
				userIsLogin:true,//会员是否登录
				vailUserFlag:false//会员信息是否完善
            }
        },
        methods:{
        	//交期的最小时间为今天
        	disabledDate (date) {
		      return date.getTime() < new Date(this.currDate).getTime()
		    },
        	getCurrDate:function(){
        		var currDate = new Date();
        		var currMonth=currDate.getMonth()+1;
        		if((currMonth+"").length<2){
        			currMonth="0"+currMonth;
        		}
        		var currStr=currDate.getFullYear()+"-"+currMonth+"-"+currDate.getDate();
        		return currStr;
        	},
        	chooseQuality: function(quality) {
				this.quality = quality;
			},
			chooseInspection: function(inspectionType) {
				this.inspectionType = inspectionType;
			},
        	//控制是否展示部件
        	isPartShow:function(k,index){
        		var that = this;
        		for(var i=0;i<that.partChangeList.length;i++){
        			if(that.partChangeList[i].name==that.partTypes[index].dictText&&i!=k){
        				return false;
        			}
        		}
        		return true;
        	},
        	//删除部件
        	delPart:function(index){
        		this.partChangeList.splice(index, 1);
        	},
        	//添加部件
        	addPart:function(){
        		var that = this;
        		for(var i=0;i<that.partTypes.length;i++){
        			let flag=true;
        			for(var j=0;j<that.partChangeList.length;j++){
        				if(that.partTypes[i].dictText==that.partChangeList[j].name){
        					flag=false;
        					break;
        				}
        			}
        			if(flag){
        				that.partChangeList.push({name:that.partTypes[i].dictText,value:''});
        				break;
        			}
        		}
        	},
        	choosePrint:function(printService){
        		var that = this;
        		if(that.printService==''){
        			this.printService=printService;
        		}else{
        			this.printService='';
        		}
        		
        	},
        	chooseLaster: function(laserService) {
				var that = this;
				if(that.laserService == '') {
					this.laserService = laserService;
				} else {
					this.laserService = '';
				}
			},
			choosePrinting: function(printingService) {
				var that = this;
				if(that.printingService == '') {
					this.printingService = printingService;
				} else {
					this.printingService = '';
				}
			},
			chooseRebranding: function(rebrandingService) {
				var that = this;
				if(that.rebrandingService == '') {
					this.rebrandingService = rebrandingService;
				} else {
					this.rebrandingService = '';
				}
			},
        	changeTab:function(orderType){
        		this.orderType=orderType;
        		if(orderType == 'spot'){
        			if(this.goodsNumber > this.maxBuyNum){
        				this.payNum = this.maxBuyNum;
        			}else{
        				this.payNum = this.goodsNumber;
        			}
        		}
        	},
        	generateQrcode:function(){
    			var that = this;
				var url = mobileGoodsDetailUrl + that.goodsCode;
				var canvas = document.getElementById("canvas");
				QRCode.toCanvas(canvas, url,{errorCorrectionLevel:"H",width:120}, function (error) {
					if (error) console.error(error)
						console.log('success!');
				});
				QRCode.toCanvas(canvas, url,{errorCorrectionLevel:"H",width:120}, function (error) {
					if (error) console.error(error)
						console.log('success!');
				});
			},
			closeqrcode:function(){
				jQuery("#js_qrcode_top").css("z-index",-1);
			},
        	easyShare:function(type){
        		var that = this;
        		var str = window.location.href;
        		var url = encodeURIComponent(str);
        		if(type=="weibo"){
        			window.open("http://service.weibo.com/share/share.php?appkey=&title="+that.goodsNameEn+"&url="+url+"&pic="+that.goodsImgs[0]);
        		}else if(type=="qzone"){
					var title = encodeURI(that.goodsNameEn);
					var pics = that.goodsImgs[0];
        			window.open("https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url="+url+"&title="+title+"&pics="+pics+"&desc=&summary=&site=");
        		}else if(type=="weixin"){
        			jQuery("#js_qrcode_top").css("z-index",999);
        			that.generateQrcode();
        		}
        	},
        	existsSku:function(specName,index){
        		var tmpArry=this.usedSkuArry[index];
        		if(this.usedSkuArry[index]!=undefined&&this.usedSkuArry[index]!=null){
        			for(var i=0;i<this.usedSkuArry[index].length;i++){
        			if(this.usedSkuArry[index][i]==specName){
        				return true;
        			}
        		}
        		}
        		return false;
        	},
        	//选择规则
        	chooseSpec:function(specName,index){
        		var that = this;
        		console.log("that.specName=="+that.specName);
        		console.log("that.specNameEn=="+that.specNameEn);
        		//this.specName = specName;
        		//debugger;
        		var chooseFlag=true;//是否所有的规格都选择了
        		that.skuList[index].skuChoosed=specName;
        		var skuStr='';
        		var skuEnStr='';
        		var unselectSKU = true;
        		for(var i=0;i<that.skuList.length;i++){
        			if(that.skuList[i].skuChoosed==""){//如果有的规格没选
        				chooseFlag=false;
        			}
        			if(i==0){
	 					var ATmpEnArry=that.skuList[i].skuValueEn.split(",");
	 					var ATmpArry=that.skuList[i].skuValue.split(",");
	 					for(var o = 0; o < ATmpEnArry.length; o++) {
	 						if(ATmpEnArry[o] == that.skuList[i].skuChoosed){
	 							skuEnStr = ATmpEnArry[o];
	 							skuStr = ATmpArry[o];
	 						}
						}
        				//skuEnStr=that.skuList[i].skuChoosed;
        				//skuStr=that.skuList[i].skuValue;
        			}else{
	 					var ATmpEnArry=that.skuList[i].skuValueEn.split(",");
	 					var ATmpArry=that.skuList[i].skuValue.split(",");
	 					for(var o = 0; o < ATmpEnArry.length; o++) {
	 						if(ATmpEnArry[o] == that.skuList[i].skuChoosed){
	 							skuEnStr+="_"+ATmpEnArry[o];
	 							skuStr+="_"+ATmpArry[o];
	 						}
						}
        			}
        			if(that.skuList[i].skuChoosed==null||that.skuList[i].skuChoosed==""){
        				unselectSKU=false;
        			}
        		}
        		that.unselectSKU = unselectSKU;
        		console.log("skuStr=="+skuStr);
        		console.log("skuEnStr=="+skuEnStr);
        		that.specName = skuStr;
        		that.specNameEn = skuEnStr;
        		var goodsSku=that.goodsSkuMap.get(skuStr);
        		if(goodsSku!=undefined){
        			that.goodsNumber=parseInt(goodsSku.goodsNumber);
        			//that.saleNumber=parseInt(goodsSku.saleNumber);
        			that.goodsPrice = (goodsSku.unitPrice/100).toFixed(2) ;
        			that.chooseGoodsPrice = goodsSku.unitPrice/100;
        			that.brokerPrice = (goodsSku.unitPrice*that.brokerDiscountPersent/100/100).toFixed(2) ;
        		}
        		/*else{
        			if(chooseFlag){
        				that.goodsNumber=0;
        				that.saleNumber=0;
        				that.goodsPrice = 0;
        			}
        		}*/
        		//that.skuList[index].skuChoosed
        		var goodsSkuStr='';
        		for(var j=0;j<that.skuList.length;j++){
        			if(j==0){
        				goodsSkuStr+=that.skuList[j].skuChoosed;
        			}else{
        				goodsSkuStr+="_"+that.skuList[j].skuChoosed;
        			}
        		}
        		for(var k=0;k<that.goodsSkuList.length;k++){
        			if(that.goodsSkuList[k].goodsSkuStr==goodsSkuStr){
        				that.priceAreaJson=that.goodsSkuList[k].priceAreaJson;
        				if(that.goodsSkuList[k].imgLarge!=undefined&&that.goodsSkuList[k].imgLarge!=""){
        					if(that.goodsSkuList[k].imgLarge.indexOf(";")!=-1){
			 			 	var imgLarge=that.goodsSkuList[k].imgLarge.substring(0,that.goodsSkuList[k].imgLarge.length-1);
                    		that.goodsImgs=imgLarge.split(";");
                    		//展示第一张图
                    		that.goodsImgLarge =  getImgUrl()+"/upload/show.htm?filePath="+that.goodsImgs[0];
                    		for (var m = 0;m<that.goodsImgs.length;m++) {
			 					that.goodsImgs[m] =  getImgUrl()+"/upload/show.htm?filePath="+that.goodsImgs[m];
			 				}
                    	}
        			}

        			}
        		}

        	},
        	choosePic:function(index){
        		this.goodsImgLarge = this.goodsImgs[index];
        	},
        	showImg:function(creditIdx,gI){
        		jQuery("#"+creditIdx).attr("src",gI);
        		jQuery("#"+creditIdx+"_div").show();
        	},
        	hideImg:function(creditIdx){
        		jQuery("#"+creditIdx+"_div").hide();
        	},
        	showAppendImg:function(creditIdx,gI_append){
        		jQuery("#"+creditIdx+'_append').attr("src",gI_append);
        		jQuery("#"+creditIdx+"_append_div").show();
        	},
        	hideAppendImg:function(creditIdx){
        		jQuery("#"+creditIdx+"_append_div").hide();
        	},
        	getMore:function(catCode){
        		var that = this;
        		that.$router.push({name:'goodsList',query:{firstCatCode:catCode}});
        	},
        	goShop:function(shopCode){
		  	 	this.$router.push({name:'shop_index',query:{shopCode:shopCode}});
//		  	 	this.$router.push({path:'shop_index',params:{shopCode:shopCode}});
		  	},
        	goDetail:function(goodsCode){
		  	 	this.$router.push({name:'goodsdetail',query:{goodsCode:goodsCode}});
		  	 	window.location.reload();
		  	},
        	toContactSupplier:function(goodsCode){
		  	 	this.$router.push({name:'contactSupplier',query:{goodsCode:goodsCode}});
		  	 	window.location.reload();
        	},
		  	/**
		  	 * 运费情况
		  	 */
        	expressChage:function(){
        		var that = this;
        		that.expressArea='';
        		var regionArea = jQuery("#expressChage").val();
        		if(regionArea==undefined){
        			regionArea='Beijing';
        		}
        		var expressFeeBoList = that.expressFeeBoList;
        		var defaultExpress="";
        		var unit = "kg";
        		if(that.expressMode=="counter"){
        			var unit = "Piece";
        		}
        		if(that.expressMode=="counter" || that.expressMode=="weight" ){
        			//按件或重量
        			for(var i=0;i<expressFeeBoList.length;i++){
	        			var express = expressFeeBoList[i];
	        			if(express.regionArea=='Default postage'){
	        				defaultExpress=express.firstNumber+unit+"below ￥"+express.firstAmount/100+", Exceeded part ￥"+express.addNumber+unit+express.addAmount/100+"";
	        			}
	        			if(regionArea==express.regionArea){
	        				that.expressArea=express.firstNumber+unit+"below ￥"+express.firstAmount/100+", Exceeded part ￥"+express.addNumber+unit+express.addAmount/100+"";
	        			}
        			}
        		}else if(that.expressMode=="constant"){
        			//固定运费
	        		for(var i=0;i<expressFeeBoList.length;i++){
	        			var expressFee = expressFeeBoList[i];
	        			if(expressFee.constantFee>0){
	        				that.expressArea = "￥"+expressFee.constantFee/100+"";
	        				break;
	        			}
	        		}
        		}
        		//默认运费
        		if(that.expressArea==""){
        			that.expressArea=defaultExpress;
        		}
        		//满XX包邮
        		var freePostageMode = that.expressBo.freePostageMode;
        		if(freePostageMode!=""&&freePostageMode!=undefined&&freePostageMode!=null){
	        		for(var i=0;i<expressFeeBoList.length;i++){
	        			var expressFee = expressFeeBoList[i];
	        			if(expressFee.freePostageAmount>0){
	        				that.expressArea = that.expressArea + "，full"+expressFee.freePostageAmount/100+"￥ for free postage";
	        				break;
	        			}
	        		}
        		}
        	} ,
         	getGoodDetail:function(goodsCode){
         		var that=this;
			 this.$http.jsonp(getAjaxUrl()+'/goods/ajax_goods_physical_detail.htm',
			 		{
			 			params:{goodsCode:goodsCode}
			 		}).then(
			 		function (ret){
			 			//--------------------取运费-----------------------
			 			that.expressBo = ret.body.data.expressBo;
			 			that.qualitys = ret.body.data.qualitys; //品质
						that.inspectionTypes = ret.body.data.inspectionTypes; //验收
			 			that.partTypes = ret.body.data.partTypes;//产品部件
			 			that.partChangeList.push({name:that.partTypes[0].dictText,value:''});
			 			that.currDate=ret.body.data.currDate;//系统当前日期
			 			var expressBo = ret.body.data.expressBo;

	        			if(expressBo != undefined && expressBo != null){
	        				that.expressFeeBoList = expressBo.expressFeeBoList;
			 				console.log(expressBo);

	        				if(expressBo.feeMode == "free_postage"){//包邮
	        					that.expressFeeDesc = "free_postage";
	        					that.expressMode="";
	        				}else if(expressBo.feeMode == "constant"){//固定邮费
	        					that.expressFeeDesc = "Fixed postage";
	        					that.expressMode="constant";
	        					that.expressChage();
	        				}else if(expressBo.feeMode == "weight"){
	        					that.expressFeeDesc = "By weight";
	        					that.expressMode="weight";
	    	        			that.expressChage();
	        				}else if(expressBo.feeMode == "counter"){
	        					that.expressFeeDesc = "Calculated by piece";
	        					that.expressMode="counter";
	        					that.expressChage();
	        				}else{
	        					that.expressFeeDesc = "free postage";
	        				}
	        			}else{
	        				that.expressFeeDesc = "free postage";
	        			}

			 			//------------------取商品其它信息--------------------
			 			var good =  ret.body.data.goods;
			 			if(good != undefined){
			 				that.goodsBo = good;
			 			}
			 			if(that.orderType==undefined||that.orderType==''){
			 				if(good.productType=="meterial"){
				 				that.orderType="purchase";
				 			}else if(good.productType=="sample"){
				 				that.orderType="custom";
				 			}else if(good.productType=="product"){
				 				that.orderType="spot";
				 			}else{
				 				that.orderType="custom";
				 			}
			 			}
			 			if(that.orderType=='spot'){
			 				if(good.goodsNumber<=10){//库存小于或等于10时为无现货，默认为订购
		 						that.orderType="custom";
		 					}
			 			}
			 			that.nextSecckill = ret.body.data.nextSecckill;//最新的秒杀活动信息
						//设置下场秒杀活动开始时间
						if(that.nextSecckill!=undefined){
							if(that.nextSecckill.activityBeginTime!=undefined && that.nextSecckill.activityBeginTime>0){
								that.nextBeginTime = that.nextSecckill.activityBeginTime;
							}
						}
//			 			if(good.attrValue!=undefined && good.attrValue!=""){
			 				that.goodsDetail = JSON.parse(good.attrValue);
			 				that.marketPrice = JSON.parse(good.attrValue).marketPrice / 100;
			 				var isSpike = JSON.parse(good.attrValue).isSpike;
			 				if(isSpike!=undefined&&isSpike!=''){
			 					that.isSpike=isSpike;
			 				}
			 				var saleTimeStr=JSON.parse(good.attrValue).saleTimeShow;
	 						var saleEndTimeStr=JSON.parse(good.attrValue).saleEndTimeShow;

	 						if(saleEndTimeStr!=undefined&&saleEndTimeStr!=''){
			 					saleEndTimeStr=saleEndTimeStr.replace(/-/g,"/");
								var saleEndDate = new Date(saleEndTimeStr);

								saleTimeStr=saleTimeStr.replace(/-/g,"/");
								var saleDate = new Date(saleTimeStr);

								//如果当期日期大于销售结束日期
								if(new Date() > saleEndDate){
									good.saleStatus="end";
								}else if(new Date() < saleDate){//如果当期时间小于上架时间，展示距离开始 时间
									good.saleStatus="wait_start";
									var begSeconds = saleDate.getTime() - new Date().getTime();   //时间差的毫秒数
    								//计算出相差天数
//  								var days=Math.floor(begSeconds/(24*3600*1000));
    								//计算出小时数
    								var leave1=begSeconds%(24*3600*1000);    //计算天数后剩余的毫秒数
    								var hours=Math.floor(begSeconds/(3600*1000));
    								//计算相差分钟数
    								var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数
    								var minutes=Math.floor(leave2/(60*1000));
    								//计算相差秒数
    								var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数
   									var seconds=Math.round(leave3/1000);
// 									good.day=days;
   									that.hour=hours;
   									that.minute=minutes;
   									that.second=seconds;
								}else{
									good.saleStatus="on_sale";

									var begSeconds = saleEndDate.getTime() - new Date().getTime();   //时间差的毫秒数
    								//计算出相差天数
//  								var days=Math.floor(begSeconds/(24*3600*1000));
    								//计算出小时数
    								var leave1=begSeconds%(24*3600*1000);    //计算天数后剩余的毫秒数
    								var hours=Math.floor(begSeconds/(3600*1000));
    								//计算相差分钟数
    								var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数
    								var minutes=Math.floor(leave2/(60*1000));
    								//计算相差秒数
    								var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数
   									var seconds=Math.round(leave3/1000);
// 									good.day=days;
   									that.hour=hours;
   									that.minute=minutes;
   									that.second=seconds;
								}
			 				}
//			 			}
						that.attrValue = JSON.parse(good.attrValue);
						//产品详情图片路径添加绝对路径
			 			that.goodsDesc = good.goodsDesc.replace(/\/upload\//g, API.getImgPath()+"/upload/");
			 			that.goodsDescEn = good.goodsDescEn.replace(/\/upload\//g, API.getImgPath()+"/upload/");
			 			that.goodsName = good.goodsName;
			 			that.goodsNameEn = good.goodsNameEn;
			 			that.catCode = good.catCode;
			 			that.firstCatCode = that.attrValue.firstCatCode;
			 			that.getRecommendGoods();
			 			that.seckillPrice = good.seckillPrice;
			 			if(that.seckillPrice>0){
			 				that.activityEndTime = good.activityEndTime;
			 			}
			 			that.spec=JSON.parse(good.attrValue).spec;
			 			if(that.spec!=undefined&&that.spec!=''){
			 				that.specName=that.spec.split(',')[0];
			 			}
			 			/*if(ret.body.data.brokerDiscountPersent != undefined){
							that.brokerDiscountPersent=ret.body.data.brokerDiscountPersent;
							that.brokerPrice = (good.unitPrice*that.brokerDiscountPersent/100/100).toFixed(2) ;
						}*/
						//unitPrice 是产品单价
						that.goodsPrice1=good.goodsPrice;
						that.pointType=good.pointType;
			 			that.goodsPrice = (good.unitPrice/100).toFixed(2) ;
			 			that.goodsCode = good.goodsCode;
			 			that.goodsCatNameCn = good.ext3;
			 			//从返回的类目对象中获取英文名称
			 			var goodsCatInfo =  ret.body.data.goodsCatInfo;
			 			if(goodsCatInfo != undefined){
			 				that.goodsCatName = goodsCatInfo.catName;
			 			}
			 			
			 			//这个地方估计有坑~
			 			var imgArray = [];
			 			 if(good.imgLarge.indexOf(";")!=-1){
			 			 	good.imgLarge=good.imgLarge.substring(0,good.imgLarge.length-1);
                    		that.goodsImgs=good.imgLarge.split(";");
                    		good.imgLarge = that.goodsImgs[0];
                    	}
			 			that.goodsImgLarge =  getImgUrl()+"/upload/show.htm?filePath="+good.imgLarge;
			 			for (var j = 0;j<that.goodsImgs.length;j++) {
			 				that.goodsImgs[j] =  getImgUrl()+"/upload/show.htm?filePath="+that.goodsImgs[j];
			 			}


//			 			that.goodsImgs.push(that.goodsImgLarge);
//			 			that.goodsImgs.push(that.goodsImgMid);
//			 			that.goodsImgs.push(that.goodsImgSml);

						that.goodsNumber = good.goodsNumber
						that.discount = (that.goodsPrice / that.marketPrice * 10).toFixed(2);
			 			that.breaks = parseFloat(that.marketPrice-that.goodsPrice).toFixed(2);
			 			that.saleNumber  = good.saleNumber;
			 			that.inpSaleNumber  = good.inpSaleNumber;
			 			that.shopCode = good.shopCode;
			 			that.shopName = good.shopName;
			 			that.shopNameEn = good.shopNameEn;

			 			var goodsSkuMap = that.goodsSkuMap;
			 			var goodsSkuList =  ret.body.data.goodsSkuList;
			 			
			 			if(goodsSkuList==null||goodsSkuList.length<=1){
			 				that.unselectSKU = true;//代表规格已经全部选择
			 			}
			 			if(goodsSkuList==null){//如果商品未关联SKU
			 				if(good.priceAreaJson!=undefined&&good.priceAreaJson!=null){
			 					that.priceAreaJson=good.priceAreaJson;
			 				}
			 			}else{//初始化多级报价为第一条SKU里面的值
			 				that.priceAreaJson=goodsSkuList[0].priceAreaJson;
			 				if(goodsSkuList[0].priceAreaJson!=undefined&&goodsSkuList[0].priceAreaJson!=null){
			 					that.priceAreaJson=goodsSkuList[0].priceAreaJson;
			 				}
			 			}
			 			var defaultSkuArry='';//默认选择的SKU
			 			var usedSkuArry=that.usedSkuArry;//商品使用的SKU，二维数组
			 			var skuList =  ret.body.data.skuList;
			 			//debugger;
			 			if(skuList != undefined){
			 				that.skuList = skuList;
			 			}
			 			if(goodsSkuList != undefined){
			 				that.goodsSkuList = goodsSkuList;
			 				var goodsNum = 0;
			 				var minPrice = 0;
			 				var maxPrice = 0;
			 				for(var i=0;i<goodsSkuList.length;i++){
			 					goodsNum+=goodsSkuList[i].goodsNumber;
			 					//英文从英文字段获取
			 					var tmpArry=goodsSkuList[i].goodsSkuStrEn.split("_");
			 					for(var o = 0; o < tmpArry.length; o++) {
									if(i == 0) {
										usedSkuArry.push(new Array(tmpArry[o]));
									} else {
										usedSkuArry[o].push(tmpArry[o]);
									}
									//
									for(var m = 0; m < skuList.length; m++) {
										if(skuList[m].skuValueEn.indexOf(tmpArry[o])==-1){
											skuList[m].skuValueEn+=","+tmpArry[o];
										}
									}
								}
			 					goodsSkuMap.set(goodsSkuList[i].goodsSkuStr,goodsSkuList[i]);
			 					if(goodsSkuList[i].isDefault=='y'){
			 						//选中默认
			 						//if(goodsSkuList.length<=1){
			 							that.unselectSKU = true;//选择了默认的SKU
			 							that.specName = goodsSkuList[i].goodsSkuStr;
			 							that.specNameEn = goodsSkuList[i].goodsSkuStrEn;
				 						that.goodsNumber=parseInt(goodsSkuList[i].goodsNumber);
				 						//that.saleNumber=parseInt(goodsSkuList[i].saleNumber);
			 							defaultSkuArry=goodsSkuList[i].goodsSkuStrEn.split("_");
			 						//}
			 						
			 					}
			 					if(i==0||(minPrice>goodsSkuList[i].unitPrice/100)){
			 						minPrice = goodsSkuList[i].unitPrice/100;
			 					}
			 					if(goodsSkuList[i].unitPrice / 100 > maxPrice) {
									maxPrice = goodsSkuList[i].unitPrice / 100;
								}

			 				}
			 				that.goodsPrice = minPrice.toFixed(2) ;
			 				that.brokerPrice = (minPrice*that.brokerDiscountPersent/100).toFixed(2) ;
//							that.goodsNumber = goodsNum;
							that.maxPrice = maxPrice;
							that.minPrice = minPrice;
							
			 			}else{
			 				that.chooseGoodsPrice = good.unitPrice;
			 			}
			 			//商品总库存小于或等于10的现货商品，默认展示订购页面
			 			if((that.goodsBo.goodsNumber==undefined||that.goodsBo.goodsNumber<=10)&&that.orderType=='spot'){
			 				that.orderType="custom";
			 			}
			 			
			 			if(skuList!=undefined&&skuList!=''){  //没看仔细看逻辑  这里可能为空
			 				for(var m=0;m<skuList.length;m++){
			 				if(defaultSkuArry.length>=m){

			 					skuList[m].skuChoosed=defaultSkuArry[m];
			 					}
			 				}
			 			}
console.log(usedSkuArry);
			 			that.getShopInfo(good.shopCode);
			 			//店铺是否收藏
			 			that.existFavoriteShop();
	 					that.computeFlag = window.setInterval(function(){
	 						that.computeTime();//计算倒计时
	 					},1000);
						 //判断商品是否虚拟商品firstCatCode"virtual_commodity"
				                    if(that.goodsDetail.firstCatCode!=undefined && that.goodsDetail.firstCatCode=="virtual_commodity"){
				                    	that.canAddToShoppingCart = false;
				                    }
			 		},  function (err){
//			 			alertConfirm.singleConfirm("异步请求操作失败")
			 		}
			 	)},
			 	getGoodCredits:function(goodsCode,currentPage,pageSize){
			 		var that=this;
			 		API.getGoodCredits(goodsCode,currentPage,pageSize,function(ret){
			 			if(ret.code == "success"){
			 				var goodRate=ret.data.goodRate;
			 				if(goodRate!=undefined){
			 					that.goodRate=goodRate;
			 				}
			 				var creditList = ret.data.creditBos;
				 			for(var i=0;i<creditList.length;i++){
				 				var gmtCreate=creditList[i].gmtCreate+"";
				 				var yy = gmtCreate.substring(0, 4);
								var mm = gmtCreate.substring(4, 6);
								var dd = gmtCreate.substring(6, 8);
								var hh = gmtCreate.substring(8, 10);
								var MM = gmtCreate.substring(10, 12);
								var ss = gmtCreate.substring(12, 14);
								var dataStr= yy + "." + mm + "." + dd + " " + hh + ":" + MM + ":" + ss;
				 				creditList[i].dataStr = dataStr;

				 				var buyerName = creditList[i].buyerAccount;
				 				if(buyerName!=undefined&&buyerName.length>1){
				 					buyerName=buyerName.substr(0, 1)+"****"+buyerName.substr(-1);
				 				}
				 				creditList[i].buyerName=buyerName;
				 				var imgs=creditList[i].ext1;
				 				if(imgs!=undefined&&imgs!=""){
				 					creditList[i].creditImgs=imgs.split(";");
				 					//alertConfirm.singleConfirm(creditList[i].creditImgs);
				 					for (var j = 0;j<creditList[i].creditImgs.length;j++) {
				 						if(creditList[i].creditImgs[j]!=undefined&&creditList[i].creditImgs[j]!=""){
				 							creditList[i].creditImgs[j] =  getImgUrl()+"/upload/show.htm?filePath="+creditList[i].creditImgs[j];
				 						}else{
				 							creditList[i].creditImgs.splice(j, 1);
				 						}

			 						}
				 				}

				 				var appendimgs=creditList[i].ext3;
				 				if(appendimgs!=undefined&&appendimgs!=""){
				 					creditList[i].appendImgs=appendimgs.split(";");
				 					//alertConfirm.singleConfirm(creditList[i].creditImgs);
				 					for (var j = 0;j<creditList[i].appendImgs.length;j++) {
				 						if(creditList[i].appendImgs[j]!=undefined&&creditList[i].appendImgs[j]!=""){
				 							creditList[i].appendImgs[j] =  getImgUrl()+"/upload/show.htm?filePath="+creditList[i].appendImgs[j];
				 						}else{
				 							creditList[i].appendImgs.splice(j, 1);
				 						}

			 						}
				 				}
				 			}
				 			that.creditList = creditList;
			 			}
			 		});
			 	},
			getGoodDetails:function(goodsCode){
  	 	        this.$router.push({path:'goodsDetails',query:{goodsCode:goodsCode}});
  	        },
  	        getGoodList:function(catCode,catNameCn){
  	 	        this.$router.push({path:'goodsList',query:{catCode:catCode,catNameCn:catNameCn}});
  	        },
  	        getGoodListEn:function(catCode,catName){
  	 	        this.$router.push({path:'goodsList',query:{catCode:catCode,catName:catName}});
  	        },
        	getShoppingCartNum:function(shopCode){
        		var that=this;
        		API.getShoppingCartNum(function(ret){
        			that.shoppingCartNum = ret.data.shoppingCartNum;
        		});
        	},
           getShopInfo:function(shopCode){
        		var that=this;
			 	this.$http.jsonp(getAjaxUrl()+'/shop/ajax_shop_index.htm',{
			 		params: {shopCode:shopCode}
				 }).then(
			 		function (ret){
			 			if(ret.body.code == "success"){
			 				var info =ret.body.data.shopBo;
				 			that.shopInfo = info
				 			if(info.shopLogo!=undefined&&info.shopLogo!=""){
				 				that.shopLogo =	getImgUrl()+"/upload/show.htm?filePath="+info.shopLogo;
				 			}
				 		 	if(info.qq == undefined || info.qq ==''){
				 				that.qqUrl = "javascript:volid(0);";
				 			}else{
				 				that.qqUrl = "http://wpa.qq.com/msgrd?v=3&site=qq&menu=yes&uin="+info.qq;
				 			}
			 			}
			 		},function (err){
//			 			alertConfirm.singleConfirm("异步查询店铺信息失败")
			 		})
        	},
        	addPayNum:function(){
        		this.payNum = parseInt(this.payNum) + 1;
        		if(this.orderType == 'spot' && (this.payNum > this.goodsNumber || this.payNum > this.maxBuyNum)){
        			alertConfirm.singleConfirm("Please choose to order business",function(){});
        			if(this.goodsNumber > this.maxBuyNum){
        				this.payNum = this.maxBuyNum;
        			}else{
        				this.payNum = this.goodsNumber;
        			}
        			return false;
        		}
        	},
        	subPayNum:function(){
        		if(this.payNum > 1){
        			this.payNum = parseInt(this.payNum)- 1;
        		}
        	},
        	setPayNum: function(){
        		var _payNum = parseInt(jQuery("#payNum").val());
        		//只是现货商品才需要控制订单的购买数量
        		if(this.orderType == 'spot' && (_payNum > this.goodsNumber || _payNum > this.maxBuyNum)){
        			alertConfirm.singleConfirm("Please choose to order business",function(){});
        			if(this.goodsNumber > this.maxBuyNum){
        				this.payNum = this.maxBuyNum;
        			}else{
        				this.payNum = this.goodsNumber;
        			}
        			return false;
        		}else if(_payNum <= 0){
        			this.payNum = 1;
        			return false;
        		}
        		this.payNum = _payNum;
        	},
        	setProduceNum: function(){
        		var _produceNum = parseInt(jQuery("#produceNum").val());
        		//只是现货商品才需要控制订单的购买数量
        		if(_produceNum <= 0){
        			this.produceNum = 1;
        			return false;
        		}
        		this.produceNum = _produceNum;
        	},
        	//订购申请
        	customizeApply: function(applyType) {
        			var that = this;
        			var customize_desc = that.customize_desc;
        			if(applyType == 'subscribe') {
        				if(customize_desc == undefined||customize_desc == '') {
        					/*alertConfirm.singleConfirm("Please enter the ordering instructions！");
        					return;*/
        				} else {
        					customize_desc = encodeURI(customize_desc);
        				}
        			}
        			var remark = '';
        			if(that.remark == '') {
        				/*alertConfirm.singleConfirm("Please enter a note！");
        				return;*/
        			} else {
        				remark = encodeURI(that.remark);
        			}
        			var deleveryTime = '';
        			var begin_delivery_time = jQuery("input[name='begin_delivery_time']").val();
        			if(begin_delivery_time == '') {
        				alertConfirm.singleConfirm("Please enter the delivery date！");
        				return;
        			} else {
        				deleveryTime = begin_delivery_time.replace('-', '').replace('-', '');
        			}
        			var specName = '';
        			if(that.specName != '') {
        				specName = encodeURI(that.specName);
        			}
        			var accessory_change_json = '';
        			//var changeList = [];
        			//打样要求
        			var changeJsonStr = '';
        			if(that.partChangeList != undefined && that.partChangeList.length > 0&&that.partChangeList[0].value!="") {
        				changeJsonStr = '{';
        				for(var i = 0; i < that.partChangeList.length; i++) {
        					/*changeList.push({
        						name: encodeURI(that.partChangeList[i].name),
        						value: encodeURI(that.partChangeList[i].value)
        					});*/
        					if(that.partChangeList[i].value!=""){
        						changeJsonStr +='"'+encodeURI(that.partChangeList[i].name)+'":"'+encodeURI(that.partChangeList[i].value)+'"';
        						if(that.partChangeList.length>1&&i<(that.partChangeList.length-1)){
        							changeJsonStr +=',';
        						}
        					}
        					
        				}
        				changeJsonStr += '}';
        				/*accessory_change_json = JSON.stringify(changeList);*/
        			}
        			var formData = new FormData(jQuery("#addFileForm")[0]);
        			jQuery.ajax({
        				url: getAjaxUrl() + '/demand/attachment_upload.htm',
        				type: 'POST',
        				data: formData,
        				async: false,
        				cache: false,
        				contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
        				processData: false, // 告诉jQuery不要去处理发送的数据  
        				success: function(result) {
        					result = eval('(' + result + ')');
        					if(result.code == "success") {
        						var fileName = "";
        						if(result.data.fileName != undefined && result.data.fileName != "") {
        							fileName = encodeURI(result.data.fileName);
        						}
        						var filePath = result.data.filePath;
        						if(applyType == 'subscribe') { //订购申请,applyType:subscribe
        							API.customizeApply("goods",applyType, customize_desc, remark,
        								deleveryTime, that.goodsDetail.qualityService, 'wait', that.payNum, changeJsonStr, that.goodsCode, specName, '', '', fileName, filePath,
        								function(ret) {
        									if(ret.code != null && ret.code == "success") {
        										alertConfirm.singleConfirm("Order application submitted successfully");
        										//window.location.reload();
        									} else if(ret.code != null && ret.code == "9999") {
        										alertConfirm.singleConfirm("Log in first, please！");
        										window.location.href = getUcUrl() + '/login.htm';
        										return false;
        									} else if(ret) {
        										var errorCode = ret.code;
        										var errorMsg = 'The system is busy, please try again later';
        										alertConfirm.singleConfirm(errorMsg);
        									}
        								});
        						} else { //打样申请，需要传图片
        							var formData2 = new FormData(jQuery("#addTextForm")[0]);
        							jQuery.ajax({
        								url: getAjaxUrl() + '/demand/multi_img_upload.htm',
        								type: 'POST',
        								data: formData2,
        								async: false,
        								cache: false,
        								contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
        								processData: false, // 告诉jQuery不要去处理发送的数据  
        								success: function(result2) {
        									result2 = eval('(' + result2 + ')');
        									if(result2.code == "success") {

        										var imageName = "";
        										if(result2.data.imgName != undefined && result2.data.imgName != "") {
        											imageName = encodeURI(result2.data.imgName);
        										}
        										var imagePath = result2.data.imgPath;
        										customize_desc="";//打样申请,不需要传 订购说明 这个参数
												//打样申请,applyType:proof
        										API.customizeApply("goods",applyType, customize_desc, remark,
        											deleveryTime,  that.quality, 'wait', that.payNum, changeJsonStr, that.goodsCode, specName, imageName, imagePath, fileName, filePath,
        											function(ret) {
        												if(ret.code != null && ret.code == "success") {
        													alertConfirm.singleConfirm("Proof application submitted successfully");
        													//window.location.reload();
        												} else if(ret.code != null && ret.code == "9999") {
        													alertConfirm.singleConfirm("Log in first, please！");
        													window.location.href = getUcUrl() + '/login.htm';
        													return false;
        												} else if(ret) {
        													var errorCode = ret.code;
        													var errorMsg = 'The system is busy, please try again later';
        													alertConfirm.singleConfirm(errorMsg);
        												}
        											});
        									} else {
        										alertConfirm.singleConfirm(result.msg);
        									}
        								},
        								error: function(ret) {
        									alertConfirm.singleConfirm("Image upload failed！");
        								}
        							});
        						}

        					} else {
        						alertConfirm.singleConfirm(result.msg);
        					}
        				},
        				error: function(ret) {
        					alertConfirm.singleConfirm("Attachment upload failed！");
        				}
        			});

        		},
        		payOrder: function() {
        			if(!this.unselectSKU) {
        				alertConfirm.singleConfirm("Please select product attributes！");
        				return;
        			}
        			var that=this;
        			var priceNum = that.goodsPrice;
        			if(priceNum === undefined||priceNum ==="0"){
	        				alertConfirm.singleConfirm("There is no quotation for the goods, please contact customer service");
		        			return false;
	        			}
        			var goodsCode = this.goodsCode;
        			if(that.orderType=="spot"){//现货下单，表单验证
        				if(this.goodsNumber === 0){
	        				return
	        			}
		        		var that = this;
		        		var num = jQuery("#payNum").val();
		        		if(num<1){
		        			alertConfirm.singleConfirm("The purchase quantity cannot be 0");
		        			return false;
		        		}
		        		var payNum = parseInt(that.payNum);
		        		if(this.orderType == 'spot'&&parseInt(this.payNum) > this.goodsNumber){
		        			alertConfirm.singleConfirm("Please choose to order business");
		        			this.payNum = this.goodsNumber;
		        			return false;
		        		}
        			}
	        		if(that.orderType=="purchase"){//采购订单，表单验证
	        			var produceNum = that.produceNum;
						if(produceNum == null || produceNum < 1) {
							alertConfirm.singleConfirm("Please enter the production quantity of a positive integer");
							return false;
						}
						if(that.quality == '') {
							alertConfirm.singleConfirm("Please select quality service");
							return false;
						}
						if(that.inspectionType == '') {
							alertConfirm.singleConfirm("Please select the inspection method");
							return false;
						}
						var remark='';
						if(that.remark == '') {
							alertConfirm.singleConfirm("Please enter the processing instructions");
							return false;
						}else{
							remark = encodeURI(that.remark);
						}
	        		}
	        		
	        		API.checkUnpaidOrder(goodsCode,function(ret){
	        			if(ret.code == "9999"&& ret.msg == "auth vaild fail!"){
	        				alertConfirm.singleConfirm("Please login",function(){
	        					window.location.href=getUcUrl() + '/login.htm';
	        				});
	        				return false;
	        			}

        				var payNum = parseInt(that.payNum);
						var surplusNumberVal = that.goodsBo.goodsNumber;
						
						var currentNum = that.currentNum;
						var buyGoodsNumber = that.buyGoodsNumber;
						var goodsLimitMax = that.goodsDetail.goodsLimitMax;
						var goodsLimit = that.goodsDetail.goodsLimit;
						var saleTime = that.goodsDetail.saleTime;
						var goodsQuota = that.goodsQuota;
						var isLimitGoodsFlag = that.isLimitGoodsFlag;

						var supplerAccount = that.goodsDetail.supplerAccount;
						var shopAccount = that.goodsDetail.shopAccount;
						var goodsAttrValue = that.goodsDetail.attrValue;
						if(that.orderType=="spot"){//现货下单
							var formData = new FormData(jQuery("#addFileForm")[0]);
							jQuery.ajax({
								url: getAjaxUrl() + '/demand/attachment_upload.htm',
								type: 'POST',
								data: formData,
								async: false,
								cache: false,
								contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
								processData: false, // 告诉jQuery不要去处理发送的数据  
								success: function(result) {
									result = eval('(' + result + ')');
									if(result.code == "success") {
										var fileName = "";
										if(result.data.fileName != undefined && result.data.fileName != "") {
											fileName = encodeURI(result.data.fileName);
										}
										var filePath = result.data.filePath;
										that.$router.push({
											name: 'ordercommit',
											query: {
												goodsCode: goodsCode,
												shopCode: that.shopCode,
												shopName: that.shopName,
												shopNameEn: that.shopNameEn,
												payNum: payNum,
												orderSource: "noCart",
												distributeAccount: that.distributeAccount,
												distributeName: that.distributeName,
												specName: that.specName,
												specNameEn: that.specNameEn,
												printServicePara: that.printService,
												fileNamePara:fileName,
												filePathPara:filePath,
												orderType:that.orderType
											}
										});
									} else {
										alertConfirm.singleConfirm(result.msg);
									}
								},
								error: function(ret) {
									alertConfirm.singleConfirm("Attachment upload failed！");
								}
							});
					}else if(that.orderType=="purchase"){//采购订单
						var formData = new FormData(jQuery("#addTextForm")[0]);
							jQuery.ajax({
								url: getAjaxUrl() + '/demand/multi_img_upload.htm',
								type: 'POST',
								data: formData,
								async: false,
								cache: false,
								contentType: false, // 告诉jQuery不要去设置Content-Type请求头  
								processData: false, // 告诉jQuery不要去处理发送的数据  
								success: function(result) {
									result = eval('(' + result + ')');
									if(result.code == "success") {
										var imageName = "";
										if(result.data.imgName != undefined && result.data.imgName != "") {
											imageName = encodeURI(result.data.imgName);
										}
										var imagePath = result.data.imgPath;
										that.$router.push({
											name: 'ordercommit',
											query: {
												goodsCode: goodsCode,
												shopCode: that.shopCode,
												shopName: that.shopName,
												shopNameEn: that.shopNameEn,
												payNum: that.produceNum,
												orderSource: "noCart",
												distributeAccount: that.distributeAccount,
												distributeName: that.distributeName,
												specName: that.specName,
												rebrandingServicePara: that.rebrandingService, //换标服务
												printingServicePara: that.printingService, //印花服务
												laserServicePara: that.laserService, //激光服务
												imageNamePara:imageName,
												imagePathPara:imagePath,
												orderType:that.orderType
											}
										});
									} else {
										alertConfirm.singleConfirm(result.msg);
									}
								},
								error: function(ret) {
									alertConfirm.singleConfirm("Image upload failed！");
								}
							});
					}

});

},
refreshGoods: function() {
		if(this.currentPage < this.totalPage) {
			this.currentPage += 1;
		} else if(this.currentPage == this.totalPage) {
			this.currentPage = 1;
		}
		this.getRecommendGoods();
	},
	getRecommendGoods: function() {
		var that = this;
		var interval ="intervalAll";
				var catCode = that.catCode;
				var cabinetId = "";
				var pageSize = 5;
				var isQueryAll = "n";
				var currentPage = that.currentPage;
				var orderBy = "sale_number";
				var orderAsc = "desc";
			    var shopCode = "";
			    var sortTime = "";
			    var goodsName = "";
			    var goodsNameEn = "";
			    var firstCatCode = "";
			    var brandId = 0;
			    var productType="";
			    var orderType="";
				API.getGoodsList(cabinetId,catCode,interval,currentPage,orderBy,orderAsc,shopCode,sortTime,pageSize,isQueryAll,goodsName,goodsNameEn,firstCatCode,brandId,productType,orderType,function(ret){
					if(ret.code == "success"){
						that.totalPage = ret.data.totalPage;
						var goods = ret.data.goods;
						if(goods != undefined){
							for(var i=0;i<goods.length;i++){
								//商品图片
								var imgMiddle = goods[i].imgMiddle;
			                    if(imgMiddle.indexOf(";")!=-1){
			                    	imgMiddle=imgMiddle.split(";")[0];
			                    }
			                    imgMiddle = getImgUrl()+"/upload/show.htm?filePath="+imgMiddle;
			                    goods[i].imgMiddle = imgMiddle;
							}
						}
						that.recommendGoodsList = goods;
					}
				});
			 },
        	addToShoppingCart:function(){
        		if(!this.unselectSKU){
        			alertConfirm.singleConfirm("Please select product attributes！");
        			return;
        		}
        		if(this.goodsNumber === 0){
        			return
        		}
        		var that = this;
        		var priceNum = that.goodsPrice;
        		if(priceNum === undefined||priceNum ==="0"){
	        				alertConfirm.singleConfirm("There is no quotation for the goods, please contact customer service");
		        			return false;
	        			}
        		var specName=that.specName;
          		if(specName!=undefined&&specName!=''){
          			specName=encodeURI(specName);
          		}
        		var specNameEn=that.specNameEn;
          		if(specNameEn!=undefined&&specNameEn!=''){
          			specNameEn=encodeURI(specNameEn);
          		}
        		var goodsCode = that.goodsCode;
        		var operationDesc = "add to Shopping Cart";
        		var num = jQuery("#payNum").val();
        		if(num<1){
        			alertConfirm.singleConfirm("The purchase quantity cannot be 0");
        			return false;
        		}
        		API.checkUnpaidOrder(goodsCode,function(ret){
        		   if (ret.code != undefined && ret.code == '9999') {
						window.location.href=getUcUrl() + '/login.htm';
						return false;
					}
        				var payNum = parseInt(that.payNum);
						var surplusNumberVal = that.goodsDetail.goodsNumber;
						var currentNum = that.currentNum;
						var buyGoodsNumber = that.buyGoodsNumber;
						var goodsLimitMax = that.goodsDetail.goodsLimitMax;
						var goodsLimit = that.goodsDetail.goodsLimit;
						var saleTime = that.goodsDetail.saleTime;
						var goodsQuota = that.goodsQuota;
						var isLimitGoodsFlag = that.isLimitGoodsFlag;

						var supplerAccount = that.goodsDetail.supplerAccount;
						var shopAccount = that.goodsDetail.shopAccount;
						var goodsAttrValue = that.goodsDetail.attrValue;
							if(supplerAccount==undefined){
								supplerAccount='';
							}
							if(shopAccount==undefined){
								shopAccount='';
							}
							if(goodsAttrValue==undefined){
								goodsAttrValue='';
							}
						if(Date.parse(saleTime) > new Date()) {
							alertConfirm.singleConfirm('The item has not yet been sold');
						}else if(isLimitGoodsFlag && parseInt(goodsQuota) < parseInt(payNum)){
							alertConfirm.singleConfirm('The number exceeds the limit purchase quantity');
						}else if(parseInt(payNum) > parseInt(surplusNumberVal)){
							alertConfirm.singleConfirm(operationDesc+'number exceeds the number of purchases');
						}else if((goodsLimitMax != '0') && parseInt(payNum) > (parseInt(goodsLimitMax)-parseInt(buyGoodsNumber))){
							alertConfirm.singleConfirm(operationDesc+'number exceeds the limit purchase quantity');
						}else if (parseInt(payNum)<goodsLimit) {
							alertConfirm.singleConfirm(operationDesc+'number is less than enough quantity');
						}else if((parseInt(payNum)*parseInt(priceNum)) > parseInt(currentNum)){
							alertConfirm.singleConfirm(operationDesc+'total points exceed available points');
						}else if(parseInt(payNum) > 99){
							alertConfirm.singleConfirm('the number of'+ operationDesc+'s must not exceed 99');
						}else{
							API.addShoppingCart(goodsCode,payNum,supplerAccount,goodsAttrValue,shopAccount,specName,specNameEn,function(ret){
								if(ret.code == "success"){
									alertConfirm.singleConfirm("Products added to the shopping cart successfully");
									that.$refs.c1.getShoppingCartNum();
									that.$refs.c1.getShoppingCartList();
								}else{
									alertConfirm.singleConfirm(ret.msg);
								}
							});
						}
        		});
        	},
		  	goIndex:function(){
		  		this.$router.push({name:'index'});
		  	},
		  	getCatGoods:function(catCode){
		  	 	this.$router.push({name:'goodsList',params:{catCode:catCode}});
		  	},
		 	getCat:function(){
        		var that = this;
        		API.getAllCat('',function(ret){
        			if(ret.code == "success"){
        				that.catList = ret.data.firstCatList;
        			}
        		});
        	},
		 	getVailUserFlag:function(){
        		var that = this;
        		API.vailUserInfo(function(ret){
					//
					if(ret.code != null && ret.code == "success") {
		                if(ret.data.vailUserFlag == true){
		                	//alertConfirm.singleConfirm("打样申请提交成功，请进行信息完善.",function(){
		                	//	window.location.href = getUcUrl() + "/user/edit_userinfo.htm";
		                	//});
		                	//设置状态
		                	that.vailUserFlag = true;
		                }else{
		                    //alertConfirm.singleConfirm("打样申请提交成功");
		                    //window.location.reload();
		                    //设置状态
		                    that.vailUserFlag = false;
		                }
		                that.userIsLogin = true;
					} else if(ret.code != null && ret.code == "9999") {
						//alertConfirm.singleConfirm("请先登陆！");
						//window.location.href = getUcUrl() + '/login.htm';
						that.userIsLogin=false;
						return false;
					} else if(ret) {
						var errorCode = ret.code;
						var errorMsg = 'The system is busy, please try again later';
						alertConfirm.singleConfirm(errorMsg);
					}
        		});
        	},
        	toEditUserInfo:function(){
        		window.location.href = getUcUrl() + "/user/edit_userinfo.htm";
        	},
        	toUserLogin:function(){
        		window.location.href = getUcUrl() + "/login.htm";
        	},
//      	sharePage:function(){
//      		LightSDK.native.share({
//				    title:"分享的标题",
//				    content:"分享的内容简介",
//				    url:"https://www.baidu.com/", //分享出去的链接打开后显示的地址
//				    image:"https://passport.hscloud.cn/iuccasserver/statics/images/lght.jpg" //分享出去的图片
//				},function(data){
//				    if(data.error_no!="0"){
//				        alertConfirm.singleConfirm(data.error_info);
//				        return false;
//				    }else{
//				        console.log(data);//your code
//				    }
//				});
//      	}

		addOrDeleteFavoriteGoods:function() {
			var that = this;
			var goodsCode = that.goodsCode;
			if(0==that.isExistFavoriteGoods){
				API.addUserFavorite("goods",goodsCode,null,function(ret){
					if(ret.code == "9999"&& ret.msg == "auth vaild fail!"){
        				alertConfirm.singleConfirm("Sorry, log in first！");
        				window.location.href=getUcUrl() + '/login.htm';
        				return false;
        			}
					if(ret.code != null && ret.code == "success") {
						that.isExistFavoriteGoods = 1;
					}else{
						alertConfirm.singleConfirm(ret.msg);
					}
				});
			}else if(1==that.isExistFavoriteGoods){
				API.deleteFavoriteBycode("goods",goodsCode,null,function(ret){
					if(ret.code == "9999"&& ret.msg == "auth vaild fail!"){
        				alertConfirm.singleConfirm("Sorry, log in first！");
        				window.location.href=getUcUrl() + '/login.htm';
        				return false;
        			}
					if(ret.code != null && ret.code == "success") {
						that.isExistFavoriteGoods = 0;
					}else{
						alertConfirm.singleConfirm(ret.msg);
					}
				});
			}
		},
		addOrDeleteFavoriteShop:function() {
			var that = this;
			var shopCode = that.shopCode;
			if(0==that.isExistFavoriteShop){
				API.addUserFavorite("shop",null,shopCode,function(ret){
					if(ret.code == "9999"&& ret.msg == "auth vaild fail!"){
        				alertConfirm.singleConfirm("Sorry, log in first！");
        				window.location.href=getUcUrl() + '/login.htm';
        				return false;
        			}
					if(ret.code != null && ret.code == "success") {
						that.isExistFavoriteShop = 1;
					}else{
						alertConfirm.singleConfirm(ret.msg);
					}
				});
			}else if(1==that.isExistFavoriteShop){
				API.deleteFavoriteBycode("shop",null,shopCode,function(ret){
					if(ret.code == "9999"&& ret.msg == "auth vaild fail!"){
        				alertConfirm.singleConfirm("Sorry, log in first！");
        				window.location.href=getUcUrl() + '/login.htm';
        				return false;
        			}
					if(ret.code != null && ret.code == "success") {
						that.isExistFavoriteShop = 0;
					}else{
						alertConfirm.singleConfirm(ret.msg);
					}
				});
			}
		},
		existFavoriteGoods:function() {
			var that = this;
			var goodsCode = that.goodsCode;
			API.isExistFavorite("goods",goodsCode,null,function(ret){
				if(ret.code != null && ret.code == "success") {
					that.isExistFavoriteGoods = ret.data.isExist;
				}else{
					console.log("existFavorite："+ret.msg);
				}
			});
		},
		existFavoriteShop:function() {
			var that = this;
			var shopCode = that.shopCode;
			API.isExistFavorite("shop",null,shopCode,function(ret){
				if(ret.code != null && ret.code == "success") {
					that.isExistFavoriteShop = ret.data.isExist;
				}else{
					console.log("existFavorite："+ret.msg);
				}
			});
		},
		previewGoods:function(goodsCode){
			console.log(1)
			var that = this;
			API.viewGoodsDetail(goodsCode,function(ret){
				if(ret.code == "success"){
					var good = ret.data.goods;
					if(good != undefined){
		 				that.goodsBo = good;
		 			}
	 				that.goodsDetail = JSON.parse(good.attrValue);
	 				that.marketPrice = JSON.parse(good.attrValue).marketPrice / 100;
//			 			}
					//产品详情图片路径添加绝对路径
		 			that.goodsDesc = good.goodsDesc.replace(/\/upload\//g, API.getImgPath()+"/upload/");
		 			that.goodsDescEn = good.goodsDescEn.replace(/\/upload\//g, API.getImgPath()+"/upload/");
		 			that.goodsName = good.goodsName;
		 			that.goodsNameEn = good.goodsNameEn;
		 			that.catCode = good.catCode;
					//unitPrice 是产品单价
		 			that.goodsPrice = (good.unitPrice/100).toFixed(2) ;
		 			that.goodsCode = good.goodsCode;
		 			that.goodsCatNameCn = good.ext3;
		 			//从返回的类目对象中获取英文名称
		 			var goodsCatInfo =  ret.body.data.goodsCatInfo;
		 			if(goodsCatInfo != undefined){
		 				that.goodsCatName = goodsCatInfo.catName;
		 			}
		 			//这个地方估计有坑~
		 			var imgArray = [];
		 			 if(good.imgLarge.indexOf(";")!=-1){
		 			 	good.imgLarge=good.imgLarge.substring(0,good.imgLarge.length-1);
                		that.goodsImgs=good.imgLarge.split(";");
                		good.imgLarge = that.goodsImgs[0];
                	}

		 			that.goodsImgLarge =  getImgUrl()+"/upload/show.htm?filePath="+good.imgLarge;
		 			for (var j = 0;j<that.goodsImgs.length;j++) {
		 				that.goodsImgs[j] =  getImgUrl()+"/upload/show.htm?filePath="+that.goodsImgs[j];
		 			}

					that.goodsNumber = good.goodsNumber
					that.discount = (that.goodsPrice / that.marketPrice * 10).toFixed(2);
		 			that.breaks = parseFloat(that.marketPrice-that.goodsPrice).toFixed(2);
		 			that.saleNumber  = good.saleNumber;
		 			that.inpSaleNumber  = good.inpSaleNumber;
				}
			});
		},
		viewExpressFees:function(){
			var that = this;
			window.open(getEmallUrl() + '/expresspManage/express_set_view.htm?shopCode='+that.shopCode);
		},
		computeTime:function(){
			var that = this;
				var activityEndTime =new Date(dateFormat(that.activityEndTime).replace(/-/g, "/"));
				var begSeconds = activityEndTime.getTime()- new Date().getTime(); //时间差的毫秒数
				//计算出小时数
				var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
				var hours = Math.floor(begSeconds / (3600 * 1000));
				//计算相差分钟数
				var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
				var minutes = Math.floor(leave2 / (60 * 1000));
				//计算相差秒数
				var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
				var seconds = Math.round(leave3 / 1000);
				that.hour = hours + "";
				that.minute = minutes + "";
				that.second = seconds + "";
			},
			handleScroll: function(e) {
				if(Math.abs(e.currentTarget.scrollY) > 300) {
					jQuery(".top").show();
				} else {
					jQuery(".top").hide();
				}
			},
			scrollToTop: function() {
				jQuery("html,body").animate({
					scrollTop: 0
				}, 500);
			},
			//根据点击上传按钮触发input
			change_input() {
				let inputArr = jQuery('#addTextForm input');
				let add_inputId = ''; //需要被触发的input
				for (let i = 0; i < inputArr.length; i++) {
					// 根据input的value值判断是否已经选择文件
					if (!inputArr[i].value) { //如果没有选择,获得这个input的ID      
						add_inputId = inputArr[i].id;
						break;
					}
				}
				if (add_inputId) { //如果需要被触发的input ID存在,将对应的input触发
					return jQuery("#" + add_inputId).click();
				} else {
					alertConfirm.singleConfirm("Most choice" + this.imgNum + "picture");
				}
			},
			//当input选择了图片的时候触发,将获得的src赋值到相对应的img
			setImg(e) {
				let target = e.target;
				jQuery('#img_' + target.id).attr('src', getFileUrl(e.srcElement));
				jQuery('#img_' + target.id).show();
			},
			//点击图片删除该图片并清除相对的input
			deleteImg(e) {
				let target = e.target;
				let inputID = ''; //需要清除value的input
				if (target.nodeName == 'IMG') {
					target.src = '';
					inputID = target.id.replace('img_', ''); //获得需要清除value的input
					jQuery('input#' + inputID).val("");
				}
			},
			setFileName(e){
				/*let target = e.target;
				var file=jQuery('#' + target.id).files;
				var fileName=jQuery('#' + target.id).files[0].name;
				jQuery('#file_' + target.id).show();*/
			},
			//根据点击上传按钮触发input
			change_File() {
				let inputArr = jQuery('#addFileForm input');
				let add_inputId = ''; //需要被触发的input
				for (let i = 0; i < inputArr.length; i++) {
					// 根据input的value值判断是否已经选择文件
					if (!inputArr[i].value) { //如果没有选择,获得这个input的ID      
						add_inputId = inputArr[i].id;
						break;
					}
				}
				if (add_inputId) { //如果需要被触发的input ID存在,将对应的input触发
					return jQuery("#" + add_inputId).click();
				} else {
					alertConfirm.singleConfirm("Most choice" + this.imgNum + "attachments");
				}
			},
			//当input选择了图片的时候触发,将获得的src赋值到相对应的img
			setFile(e) {
				let target = e.target;
				//jQuery('#file_' + target.id).val(getFileUrl(e.srcElement).name);
//				let fileName=jQuery('#' + target.id).files[0].name;
//				jQuery('#' + target.id).text("附件"+target.id);
				jQuery('#' + target.id).show();
				jQuery('#a_' + target.id).show();
			},
			//点击图片删除该图片并清除相对的input
			deleteFile(e) {
				let target = e.target;
				let inputID = ''; //需要清除value的input
				jQuery('#a_' + inputID).hide();	
				inputID = target.id.replace('a_', ''); //获得需要清除value的input
				jQuery('input#' + inputID).val("");
				jQuery('input#' + inputID).hide();
				target.remove();
			}
       },
		beforeMount:function(){
			var that = this;
			window.scrollTo(0, 0);
			that.imgPath = getImgUrl() + "/upload/show.htm?filePath=";

			if(localStorage.getItem("account")){
				that.isLogin = true;
			}
			var goodsCode = "";
			if(that.$route.params.goodsCode != undefined){
				goodsCode = that.$route.params.goodsCode;
			}
			if(that.$route.query.goodsCode != undefined){
				goodsCode = that.$route.query.goodsCode;
			}
			//下单类型
			if(this.$route.query.orderType!=undefined&&this.$route.query.orderType!=""){
				this.orderType=this.$route.query.orderType;
			}
			//由列表页面传递过来的productType用于控制详情页面的页头点亮
			if(this.$route.query.productType!=undefined&&this.$route.query.productType!=""){
				if(that.$route.query.productType=='sample'||that.$route.query.productType=='meterial'){
					that.activeLi=that.$route.query.productType;
				}
			}
			that.goodsCode = goodsCode;
			var distributeAccount = that.$route.query.distributeAccount;
			if(distributeAccount != undefined){
				that.distributeAccount=distributeAccount;
				if(distributeAccount==""){
					that.canAddToShoppingCart = true;
				}				
			}
			var distributeName = that.$route.query.distributeName;
			if(distributeName != undefined){
				that.distributeName=distributeName;
			}
			var isPreview = that.$route.query.isPreview;
			if(isPreview != undefined && isPreview == "true"){
				that.isPreview = isPreview;
				this.previewGoods(goodsCode);
			}else{
				this.getGoodDetail(goodsCode);
			}
			this.getGoodCredits(goodsCode,1,20);
			this.existFavoriteGoods();

			this.getCat();
//			this.existFavoriteShop();
//			debugger;
			this.getVailUserFlag();
			
		},
		beforeDestroy () {
     		window.clearInterval(this.computeFlag);
  		},
		mounted(){
			jQuery(".jqzoom").jqueryzoom();
			//jQuery(".beforeDestroy").val();
			jQuery('.city_select_css').each(function (i, j) {
		        var options = jQuery(j).find("option");
		        options.attr("selected", false);
		        options.first().attr("selected", true);
		    });

			$(".sp-dt-tab .hd ul li").click(function(){
				var index=$(this).index();
				$(this).addClass("hover").siblings().removeClass();
				$(".sp-dt-tab .bd").eq(index).show().siblings(".sp-dt-tab .bd").hide();
			});

			this.$nextTick(function() {
				window.addEventListener('scroll', this.handleScroll); //滚动事件监听
			});
			
		}
	}


</script>

<style>
.datetime-picker .show-year{
	min-width: 50px!important;
}
.disableColor{
	color:#eaeaea
}
	
.shop_name_overflow{
	overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 11rem;
}
.dactive{
	background-color: gray!important;
}

.post_btmshare {
    display: block;
    margin-top: 15px;
    float: left;
    overflow: hidden;
}
.post_btmshare .post_topshare_title {
    display: block;
    float: left;
    font: 14px/28px "Microsoft Yahei";
    color: #888888;
}
.post_btmshare .post_share {
    overflow: hidden;
    width: 340px;
}
.post_btmshare .post_share li {
    float: left;
    overflow: hidden;
    width: 40px;
    height: 28px;
    margin-right: 5px;
    padding: 0;
    border: none;
}

.post_btmshare .post_share li a {
    display: block;
    position: relative;
    color: #888;
    text-decoration: none;
}
.post_btmshare .post_share .share_weixin i {
    background-position: -80px -28px;
}
.post_btmshare .post_share .share_qzone i {
    background-position: -120px -28px;
}
.post_btmshare .post_share .share_weibo i {
    background-position: -160px -28px;
}

.post_btmshare .post_share .share_weixin span:before {
    background-position: -80px 0;
}
.post_btmshare .post_share .share_qzone span:before {
    background-position: -120px 0;
}
.post_btmshare .post_share .share_weibo span:before {
    background-position: -160px 0;
}
.post_btmshare .post_share li i {
    float: left;
    position: relative;
    overflow: hidden;
    width: 40px;
    height: 28px;
    margin-right: 13px;
    border-radius: 4px;
    background: url(../../../static/images/share.png) no-repeat;
}
.post_btmshare .post_share .share_weixin i:before {
    background: #20a839;
}
.post_btmshare .post_share .share_weixin i:after {
    background: #30cc54;
}
 .post_btmshare .post_share li span:before {
    content: "";
    display: block;
    overflow: hidden;
    position: absolute;
    left: 0px;
    top: 0px;
    width: 40px;
    height: 28px;
    background: url(../../../static/images/share.png) no-repeat;
}
.post_btmshare .js_qrcode_wrap {
    width: 120px;
    height: 180px;
    padding: 20px 20px 0;
    left: 50px;
    background: #fff;
    border: 1px solid #dddddd;
    border-radius: 4px;
    position: absolute;
    transform: translateY(5%);
    z-index: -1;
}
.post_btmshare .js_qrcode_wrap .js_qrcode_arr {
    position: absolute;
    top: -7px;
    left: 14px;
    width: 11px;
    height: 7px;
    background: url(../../../static/images/sprite.png) no-repeat -309px -22px;
}
.post_btmshare .js_qrcode_wrap .js_qrcode_close {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 2px;
    top: 2px;
    background: url(../../../static/images/sprite.png) no-repeat -156px -156px;
}
.post_btmshare .js_qrcode_wrap .js_qrcode_img {
    margin-bottom: 6px;
    height: 120px;
}
.post_btmshare .js_qrcode_wrap p {
	text-align: center;
    font: 12px/20px "Sim sun";
    color: #888;
    padding: 0;
    margin: 0;
}
.delisting-bccolor{
	float: left;
    display: inline-block;
    width: 150px;
    height: 40px;
    background-color:#999;
    border-radius: 3px;
    text-align: center;
    color: #fff;
    line-height: 40px;
    font-size: 16px;

}
.city_select_css{
	padding: 5px 5px;
    border: solid 1px #c6c6c6;
}
.content img{
	display: block;
}
.top {
     position: fixed;
     right: 8rem;
     bottom: 5rem;
     z-index: 99999;
     display: none;
}
.top span {
     border-radius: 50%;
     font-size: 2rem;
     width: 2.8em;
     height: 2.8em;
     line-height: 2.8;
     text-align: center;
     display: block;
     color: #fff;
     opacity: .9;
     background-color: #ff8381;
}
select {
	width:90%;
}
</style>


// WEBPACK FOOTER //
// src/page/goods/goodsDetail.vue